<template>
  <div style="height:100%; position: relative;">
    <i class="hidden-action-icon" :class="isHidden ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'" @click="isHidden = !isHidden"></i>
    <div class="voice_dialog" v-if="voiceObj.recordShow" ref="draggableBox" :style="boxStyle" @mousedown="startDrag">
      <voice-dialog @stopRecording="stopRecording" @close="voiceDialogClose"></voice-dialog>
    </div>
    <leftCenterRightContainer class="newDiagnosis-warp" v-loading="loading" :showRight="!isHidden">
      <div class="AI_diagnosis" slot="right" v-if="voiceObj.diagnosisShow">
        <AIDiagnosis-dialog :diagnosisParams="voiceObj.diagnosisParams" @close="closeAIDiagnosis" @adopt="adopt"></AIDiagnosis-dialog>
      </div>
      <div slot="left" class="newDiagnosis-left-left w100_ borderBox" style="height: 100%;">
        <OutPatientLeft :doctorInfo="doctorInfo" @consultationTypeChange="consultationTypeChange" @choosePatient="choosePatient" @clearInfo="clearInfo" ref="outpatientLeft"></OutPatientLeft>
      </div>
      <div slot="center" class="newDiagnosis-left pr">
        <div class="newDiagnosis-content">
          <div class="top-warp backfff">
            <div class="top-warp-section">
              <div class="top-warp-content">
                <div class="top-title">
                  <!-- <div @click="goBack" class="goBack"><i class="el-icon-arrow-left"></i>返回</div> -->
                  <div class="color1F2 fwb">{{ consultationType === 1 ? '门诊' : '网诊' }}</div>
                  <div style="background-color: #FFF0E1;padding:4px 6px;" class="size12 font500 ml12 colorFE8"
                    v-if="registerResp && registerResp.timeQuantumName">预约:{{ registerResp && registerResp.timeQuantumName }}</div>
                </div>
                <div v-if="orderId" class="display-f align-i-c ">
                  <span class="size18 color1890 pointer mr16 font600 moneyBtn" @click="handleCostPreview"> ￥{{
                    $toFixed(computeTotalPrice1(drugItem, physioItem,chineseMedicineItem, otherItem,actList), 2) }}</span>
                  <div v-if="!isHelper">
                    <custom-button @click="handleEdit" size="middle"
                      v-if="orderPayFlag == '0' && isDisabled && patientForm.patientId && type != '9'">修改</custom-button>
                    <custom-button type="primary" size="middle" v-if="orderPayFlag == '0' && !isDisabled"
                      @click="(type == '3' || type == '8') ? saveDoor('1') : savePrescription('1')">{{ (type == '3' ||
      type == '8') ? '保存诊断' : '完成接诊' }}</custom-button>

                  </div>
                  <div v-if="isHelper">
                    <el-button type="primary" v-if="(type == '-6' || type == '2') && !isDisabled"
                      @click="savePrescription('1')">{{ preExamineFlag == '0' ? '提交预诊' : '保存预诊' }}</el-button>
                    <el-button
                      v-if="preExamineFlag == '1' && orderPayFlag == '0' && isDisabled && type != '3' && type != '8' && type != '9'"
                      @click="handleEdit">修改预诊</el-button>
                  </div>
                  <div class="ml12">
                    <custom-button type="info" size="middle" v-if="type == '-6'"
                      @click="deleteAllDiagnosisDialog">删除</custom-button>
                  </div>
                  <el-dropdown v-if="type != '-6' && type != '2'" class="" @command="orderHandleCommand">
                    <custom-button type="info" plain size="big">打印</custom-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="2">处方</el-dropdown-item>
                      <el-dropdown-item command="3">病历</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!-- <el-button type="primary" @click="pushOrders">一键推送</el-button> -->
                  <div class="ml12">
                    <el-button  @click="openRegister">再次挂号</el-button>
                  </div>
                  <div class="ml12" v-if="['-7', '4'].includes(type)">
                    <el-button @click="createOrderAgain">再次开方</el-button>
                  </div>
                  <div v-if="['1', '2'].includes(chooseLeftPatientInfo.order.status) && chooseLeftPatientInfo.referralDoctorList.length > 0" class="ml12">
                    <el-button :disabled="chooseLeftPatientInfo.order.referralStatus || isGroupOrder" @click="referralOpen">转诊</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="content-warp" v-if="orderId" ref="contentWarp">
           
            <div class="content-wrap-section">
              <!-- 页面冲突时显示 -->
              <div v-if="isConflict" class="borderBox w100_ tac colorFE8 back0E1 size14 mb16 border2"
                style="padding: 10px;">
                <span class="iconfont icon-a-Group2745 mr2"></span>杨哈哈正在编辑此门诊单，编辑结束前其他人不可同时编辑
              </div>
              <!-- 患者信息模块 -->
              <el-form ref="patientForm" :rules="editFormRules" inline :model="patientForm" size="small"
                class="patient-warp">
                <div class="display-f align-i-c">
                  <div class="patientBox borderR4 backfff" :class="{ 'disabled': judgeDisabled }">
                    <el-form-item v-if="chargePotential && chargePotential.crowd > 0">
                      <img :src="imgArr.a1" class="patientForm_icon">
                    </el-form-item> 
                    <el-form-item prop="patientName">
                      <el-tooltip class="item" effect="light" placement="top-start"
                        :disabled="!patientForm.patientName">
                        <div slot="content">{{ patientForm.patientName }}</div>
                        <el-select :disabled="judgeDisabled" ref="selectPatient" v-model="patientForm.patientName"
                          class="patientForm-select" placeholder="姓名" filterable remote :remote-method="getPatientInfo"
                          :loading="patientFormLoading" @change="selectPatient" reserve-keyword
                          @keyup.right.native="$refs['sex'].focus()" @keyup.enter.native="$refs['sex'].focus()"
                          :popper-append-to-body="false" popper-class="customSelectStyle">
                          <el-option v-for="item in patientList" class="option-item display-f" :key="item.patientId"
                            :label="item.patientName" :value="item.patientId">
                            <span style="width: 96px; display:inline-block" class="mr12 text-overflow">{{ item.patientName }}</span>
                            <span class="mr24">{{  item.sex | filterSex(sexDict) }}</span>
                            <span style="width: 72px; display:inline-block" class="mr24">{{ item.year }}岁{{ item.month
                              }}月</span>
                            <span style="width: 112px; display:inline-block">{{ item.phone }}</span>
                          </el-option>
                        </el-select>
                      </el-tooltip>
                    </el-form-item>
                    <el-form-item prop="sex">
                      <span class="ml8"
                        style=" display: inline-block;line-height: 36px;width:24px;">{{  patientForm.sex | filterSex(sexDict) }}</span>
                    </el-form-item>
                    <el-form-item prop="year">
                      <el-input :disabled="true" ref="year" @keyup.right.native="$refs['month'].focus()"
                        @keyup.enter.native="$refs['month'].focus()" style="width:48px" v-model="patientForm.year"
                        @blur="computeBirthday">
                      </el-input>
                      <span>岁</span>
                    </el-form-item>
                    <el-form-item prop="month">
                      <el-input :disabled="true" ref="month" @keyup.right.native="$refs['phone'].focus()"
                        @keyup.enter.native="$refs['phone'].focus()" style="width:48px;" v-model="patientForm.month">
                      </el-input>
                      <span class="mr8">月</span>
                    </el-form-item>
                    <el-form-item prop="phone">
                      <el-select :disabled="judgeDisabled" :popper-append-to-body="false"
                        popper-class="customSelectStyle" class="phone-select" v-model="patientForm.phone"
                        placeholder="患者手机号" filterable remote reserve-keyword :remote-method="getPatientInfoByPhone"
                        value-key="patientId" @change="selectPatient">
                        <el-option v-for="item in patientList" :key="item.patientId" :value="item.patientId">
                          <span style="width: 96px; display:inline-block" class="mr12">{{ item.patientName }}</span>
                          <span class="mr24">{{ item.sex | filterSex(sexDict)  }}</span>
                          <span style="width: 72px; display:inline-block" class="mr24">{{ item.year }}岁{{ item.month
                            }}月</span>
                          <span style="width: 112px; display:inline-block">{{ item.phone }}</span>
                        </el-option>
                      </el-select>
                      <el-popover
                        placement="top"
                        width="170"
                        trigger="click"
                        popper-class="popover-log"
                        :disabled="doctorId == '509'"
                        content="修改患者信息请联系收费员">
                        <!-- 20250217需求要求屏蔽 -->
                        <!-- 20250305 需求要求点击提示收费员修改 -->
                        <!-- 20251010 需求要求谭政可以编辑 -->
                        <div
                          v-show="patientForm.patientId && !isDisabled"
                          class="close-icon iconfont icon-xiug pointer"
                          slot="reference"
                          @click="editPatient('edit')"
                        ></div>
                      </el-popover>
                    </el-form-item>
                  </div>
                  <el-form-item>
                    <div class="add-btn hoverActiveStyle backfff"
                      v-if="(orderStatus == '1' || orderStatus == '2') && !judgeDisabled" @click="editPatient('add')">
                      <span class="iconfont icon-xinzenghuanz"></span>
                    </div>
                  </el-form-item>
                  <el-tooltip effect="light" popper-class="preNotes-popper" :content="editForm.preNotes" placement="top" v-if="isDoctor && editForm.preNotes">
                    <div class="preNotes">预诊备注</div>
                  </el-tooltip>
                </div>
                <div class="order-doctor-warp">
                  <div v-if="chooseLeftPatientInfo.order.referralStatus" class="order-referral">由{{ chooseLeftPatientInfo.order.originDoctorName }}转诊</div>
                  <div class="patientBox borderR4 backfff" style="overflow: hidden;" :class="{ 'disabled': judgeDisabled }">
                    <el-form-item>
                      <div class="custom-popover-wrapper" ref="doctorPopoverWrapper">
                        <div 
                          v-show="showDoctorInfo" 
                          class="custom-popover-content"
                          :style="popoverStyle"
                        >
                          {{ doctorInfo.doctorName }} {{ doctorInfo.doctorCode || '' }}<br />{{ doctorInfo.sysPostName }}
                        </div>
                        <div class="custom-popover-trigger">
                          <el-select :disabled="true" remote reserve-keyword :remote-method="getDoctorList"
                            v-model="doctorId" class="patientForm-select" placeholder="选医生" @change="selectDoctor"
                            filterable :popper-append-to-body="false" popper-class="customSelectStyle">
                            <el-option v-for="item in doctorList" class="option-item" :key="item.doctorId"
                              :label="item.doctorName" :value="item.doctorId">
                              <span>{{ item.doctorName }}</span>
                              <span class="ml10">{{ item.sysPostName }}</span>
                            </el-option>
                          </el-select>
                          <span class="click-catcher" @click="toggleDoctorInfo"></span>
                        </div>
                      </div>
                    </el-form-item>
                    <span class="size14 box"
                      style="line-height: 36px;display: inline-block;background-color: #fff;padding: 0px 8px;">{{ doctorVisitDict[patientForm.doctorVisit] }}</span>
                    <el-form-item>
                      <span class="colorD3D mr2 ml5">￥</span>
                      <el-input v-if="orderStatus == '1' || orderStatus == '2'" style="width:60px;padding-left: 0px;"
                        :disabled="isDisabled" v-model.number="isRegister.price" placeholder="挂号费"
                        @input="formatNum($event)" @focus="priceFocus(isRegister)" @blur="priceBlur(isRegister)">
                      </el-input>
                      <el-input v-else :disabled="judgeDisabled" style="width:60px;padding-left: 0px;"
                        @input="formatNum($event)" v-model.number="isRegister.registeredPrice" @focus="priceFocus(isRegister)" @blur="priceBlur(isRegister)">
                      </el-input>

                    </el-form-item>
                  </div>
                </div>
              </el-form>
              <div class="content-main">
                <!-- 病例模块 -->
                <div class="case-warp" :class="{ 'disabled': isDisabled }">
                  <div class="case-title pr borderBox">
                    <div class="font600 size15">病历</div>
                    <div class="flex">
                      <!-- <div v-if="consultationType === 1" class="voice_btn" :class="{ 'disabled': isDisabled }" >
                        <img :src="imgArr.a4" class="voice_btn_icon">
                        <div @click="openVoice">语音病历助手</div>
                      </div> -->
                      <!-- 诊前知己助手 -->
                      <el-popover
                        v-model="preConsultationHelperVisible"
                        placement="bottom-start"
                        width="452"
                        trigger="click"
                        :visible-arrow="false"
                        popper-class="pre-consultation-helper-popper">
                        <PreConsultationHelper :doctorPatientSummary="doctorPatientSummary" :orderId="orderId" :doctorId="doctorId" @close="preConsultationHelperVisible = false" />
                        <div class="preConsultationHelper" :class="{ 'preConsultationHelper_disabled': isDisabled || doctorInfo.confidant == '2' }" slot="reference" @click="showPreConsultationHelper">
                          <img :src="imgArr.a10" class="preConsultationHelper_icon">
                          <div class="preConsultationHelper_text">诊前知己</div>
                        </div>
                      </el-popover>
                      <el-button @click="handleUpload" :disabled="!(!isDisabled || (type == '4'))" size="medium">上传图片</el-button>
                      <div :class="{ 'pointerNone': isDisabled }" class="case-choose ml8 size18"
                        @click="showCase = !showCase" ref="caseBtn">
                        <span class="icon-zhedie iconfont "></span>
                      </div>
                    </div>
                    <div class="caseSet pa color1F23" v-if="showCase" ref="caseDom">
                      <div class="flex just-b align-i-c caseSet-header">
                        <span class="size16 font500">病历设置</span>
                        <el-button type="text" size="small" @click="defaultCase">恢复默认</el-button>
                      </div>
                      <div class="caseSet-content">
                        <div class="size14">选择需要展示的病历字段</div>
                        <div>
                          <el-checkbox-group v-model="chooseCaseList" @change="caseListChange">
                            <el-checkbox style="width: 25%;margin-top:20px;" v-for="k in caseList" :key="k.propertyName"
                              :label="k.propertyName" :disabled="k.requiredFlag == '1'">{{ k.displayName
                              }}</el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="case-item" :class="{ 'disabled': isDisabled }"
                    v-for="(caseItem, caseInd) in chooseCaseList" :key="caseInd">
                    <template v-if="!['diagnosis','menstrualHistory','presentCondition','previousHistory','allergyHistory','specialRemark'].includes(caseItem)">
                      <div class="case-item-title"><span class="colorF54A" v-if="caseItem == 'patientTell' || caseItem == 'facePalpation'">*</span>{{ computedCaseName(caseItem) }}</div>
                      <el-input :disabled="isDisabled" type="textarea" autosize :rows="2" placeholder=""
                        class="item-textarea" v-model="editForm[caseItem]" @input="editCaseDiagnosis"
                        @change="validatePatientTell"
                        :class="{ 'isInvalid': (isInputInvalid && caseItem == 'patientTell' || ( isInputInvalidFacePalpation && caseItem == 'facePalpation')) }" maxlength="2000">
                      </el-input>
                    </template>
                    <template v-if="caseItem=='specialRemark' && (roles.includes('Doctor') || isHelper)">
                      <div class="case-item-title" :class="{ 'disabled': isHelper }">{{computedCaseName(caseItem) }}</div>
                      <el-input :disabled="isDisabled || isHelper" type="textarea" autosize :rows="2" placeholder=""
                        class="item-textarea" v-model="editForm[caseItem]" @input="editCaseDiagnosis"
                        @change="validatePatientTell" maxlength="2000">
                      </el-input>
                      <div class="item-textarea-tip">仅开方医生可见</div>
                    </template>
                    <template v-if="caseItem=='menstrualHistory'">
                      <div class="case-item-title">{{computedCaseName(caseItem) }}</div>
                      <div class="hasFast_input_warp">
                        <div
                          ref="menstruationInput"
                          class="menstruation-textarea"
                          v-html="menstrualHistoryHtml" 
                          :contenteditable="!isDisabled"
                          @blur="menstrualHistoryBlur($event)">
                        </div>
                        <el-button v-if="!isDisabled" class="fast_input_btn" type="text" @click.stop="menstrualHistoryFocus">快捷选项</el-button>
                      </div>
                      <Menstruation ref="menstruationWarp" @menstrualHistoryChange="menstrualHistoryChange" :menstrualHistory="menstrualHistory" :show="menstruationShow && !isDisabled" @close="menstruationShow=false"></Menstruation>
                    </template>
                    <template v-if="caseItem=='presentCondition'">
                      <div class="case-item-title"><span class="colorF54A">*</span>{{computedCaseName(caseItem) }}</div>
                      <div class="hasFast_input_warp">
                        <el-input
                          ref="presentConditionInput"
                          :disabled="isDisabled"
                          type="textarea"
                          autosize
                          :rows="2"
                          placeholder=""
                          class="item-textarea hasFast_input"
                          v-model="editForm[caseItem]"
                          @input="editCaseDiagnosis"
                          @change="validatePresentCondition"
                          :class="{ 'isInvalid': (isInputInvalidPresentCondition && caseItem == 'presentCondition') }"
                          maxlength="2000">
                        </el-input>
                        <el-button v-if="!isDisabled" class="fast_input_btn" type="text" @click.stop="presentConditionFocus">快捷选项</el-button>
                      </div>
                      <PresentCondition ref="presentConditionWarp" @presentConditionChange="presentConditionChange" :presentCondition="editForm[caseItem]" :show="presentConditionShow && !isDisabled" @close="presentConditionShow=false"></PresentCondition>
                    </template>
                    <template v-if="caseItem=='previousHistory'">
                      <div class="case-item-title"><span class="colorF54A">*</span>{{computedCaseName(caseItem) }}</div>
                      <div class="hasFast_input_warp">
                        <el-input
                          ref="previousHistoryInput"
                          :disabled="isDisabled"
                          type="textarea"
                          autosize
                          :rows="2"
                          placeholder=""
                          class="item-textarea hasFast_input"
                          v-model="editForm[caseItem]"
                          @input="editCaseDiagnosis"
                          @change="validatePreviousHistory"
                          :class="{ 'isInvalid': (isInputInvalidPreviousHistory && caseItem == 'previousHistory') }"
                          maxlength="2000">
                        </el-input>
                        <el-button v-if="!isDisabled" class="fast_input_btn" type="text" @click.stop="previousHistoryFocus">快捷选项</el-button>
                      </div>
                      <PreviousHistory ref="previousHistoryWarp" @previousHistoryChange="previousHistoryChange" :previousHistory="editForm[caseItem]" :show="previousHistoryShow && !isDisabled" @close="previousHistoryShow=false"></PreviousHistory>
                    </template>
                    <template v-if="caseItem=='allergyHistory'">
                      <div class="case-item-title">{{computedCaseName(caseItem) }}</div>
                      <div class="hasFast_input_warp">
                        <el-input
                          ref="allergyHistoryInput"
                          :disabled="isDisabled"
                          type="textarea"
                          autosize
                          :rows="2"
                          placeholder=""
                          class="item-textarea hasFast_input"
                          v-model="editForm[caseItem]"
                          @input="editCaseDiagnosis"
                          @change="validatePatientTell"
                          :class="{ 'isInvalid': (isInputInvalid && caseItem == 'patientTell') }"
                          maxlength="2000">
                        </el-input>
                        <el-button v-if="!isDisabled" class="fast_input_btn" type="text" @click.stop="allergyHistoryFocus">快捷选项</el-button>
                      </div>
                      <AllergyHistory ref="allergyHistoryWarp" @allergyHistoryChange="allergyHistoryChange" :allergyHistory="editForm[caseItem]" :show="allergyHistoryShow && !isDisabled" @close="allergyHistoryShow=false"></AllergyHistory>
                    </template>
                  </div>
                  <div class="case-item" :class="{ 'disabled': isDisabled }">
                    <div class="item-diagnose pr">
                      <div class="ybScope">{{ computedOrderYbScope(editForm.diagnosisList) }}</div>
                      <div style="height: 1px;width: 1px;bottom: 150px;" ref="pointDia" class="pa"></div>
                      <div class="case-item-title"><span class="colorF54A">*</span>诊断</div>
                      <el-popover popper-class="diagnosePop" placement="bottom-start" title="" class="width100"
                        trigger="manual" ref="diagnosePop" v-model="diagnosObj.diagnosVisible">
                        <div v-if="diagnosisList && diagnosisList.length > 0 && diagnosObj.diagnosVisible"
                          class="options-section" ref="diagnoseOption">
                          <div v-for="(item, index) in diagnosisList" class="option-item pointer"
                            :class="[diagnosObj.activeIndex == index ? 'active-item' : '']" :key="index"
                            @click="getDiagnosisItem(item)">
                            <div> 
                              <span>{{ item.name }}</span>
                            </div>
                            <div class="option-item-tag">
                              <div class="mr16 w60">{{ computeYbScope(item.ybScope)}}</div>
                              <div class="diagnose-recode">{{ item.recode }}</div>
                              <div class="diagnose-code">{{ item.code }}</div>
                            </div>
                          </div>
                        </div>
                        <div slot="reference" ref="diagnoseDom">
                          <el-input v-if="diagnosObj.isFocus" type="textarea" :class="{ 'disabled pointerNone': isDisabled }" autosize ref="diagnoseInput"
                            class="diagnose-input width100 item-textarea" v-model="diagnosObj.diagnosName"
                            @blur="diagnoseBlurFn" @focus="diagnoseFocusFn" @input="meetDiagnose"
                            @keydown.up.native="operatekeyDownFn('up')" @keydown.down.native="operatekeyDownFn('down')"
                            @keydown.enter.native.prevent="operatekeyDownFn('enter')"></el-input>
                          <div class="width100 diagnoseBox" v-else @click="diagnoseFocusFn" :class="{ 'disabled pointerNone': isDisabled }">
                            <template v-if="editForm.diagnosisList && editForm.diagnosisList.length>0">
                            <span :class="{'colorFE8F':k1.diagnoseCode=='' || k1.ybScope == '3'}" v-for="(k1,i) in editForm.diagnosisList" :key="i">{{k1.diagnoseName}};</span>
                            </template>
                          </div>
                        </div>
                      </el-popover>
                    </div>
                  </div>
                  <div class="case-item" :class="{ 'disabled': isDisabled }"
                    v-if="attachmentShow || editForm.imgs.length > 0" style="border-bottom: 1px solid #E1E1E1;">
                    <div class="case-item-title">附件</div>
                    <div class="attachment-warp">

                      <!-- <el-upload :disabled="isDisabled" :action="uploadUrl" :limit="9" list-type="picture-card"
                    :on-exceed="excessNum" :on-success="handleImgSuccess" :multiple="true"
                    :on-preview="handlePictureCardPreview" :file-list="fileList" name="files" :on-remove="handleRemove"
                    :with-credentials="true" :before-upload="beforeUpload" id="uploadImage" ref="uploadImage">
                    <i class="el-icon-plus"></i>
                  </el-upload> -->
                      <div class="pr" v-for="(im,imgIndex) in editForm.imgs" :key="im" :class="{ 'disabled': isDisabled }">
                        <el-image @click="handlePictureCardPreview($event,imgIndex)" :class="{ 'pointerNone': isDisabled }" class="mr8 "
                          style="width: 50px; height: 50px;border-radius: 2px ;" :src="im">

                        </el-image>
                        <div class="del pa" :class="{ 'pointerNone': isDisabled }" @click="handleRemove(im)"><i
                            class="el-icon-close size12"></i></div>

                      </div>
                      <el-image id="image" ref="images" style="height: 0px;width: 0px;position:absolute;"
                        :src="editForm.imgs[0]" :initial-index="imgIndex" :preview-src-list="editForm.imgs"></el-image>
                      <Upload :class="{ 'pointerNone': !(!isDisabled || (type == '4')) }" v-loading="uploading" ref="uploadImage"
                        @on-success="handleImgSuccess" accept=".png,.jpg,.jpeg" class="mr8">
                        <el-button class="upload" type="primary" size="small" @click="localUpload"
                          :disabled="!(!isDisabled || (type == '4'))">

                          <i class="el-icon-plus"></i>
                        </el-button>
                      </Upload>
                    </div>

                  </div>
                </div>

                <!-- 医助备注 -->
                <div class="assistant-remark" v-if="isHelper" :class="{ 'disabled': isDisabled }"> 
                  <div class="assistant-remark-title">预诊备注</div>
                  <el-input ref="assistantRemarkInput" maxlength="100" :disabled="isDisabled" show-word-limit v-model="editForm.preNotes" placeholder="请输入" @input="editCaseDiagnosis" @focus="assistantRemarkShow=true"></el-input>
                  <assistantRemark ref="assistantRemarkWarp" @assistantRemarkChange="assistantRemarkChange" :assistantRemark="editForm.preNotes" :show="assistantRemarkShow && !isDisabled" @close="assistantRemarkShow=false"></assistantRemark>
                </div>
                <!-- 处方模块 -->
                <div class="prescription-warp mt16">
                  <div class="prescription-top backfff">
                    <div class="prescription-title size14">处方项目</div>
                    <div class="prescription-btns" v-if="!isDisabled && !isGroupOrder">
                      <el-button size="medium" @click="addDrug">中药处方</el-button>
                      <el-button size="medium" @click="addChineseMedicine">中成药处方</el-button>
                      <!-- <el-button class="btn-item" @click="addCombo">隐秘处方</el-button> -->
                      <el-button size="medium" @click="addPhysio">理疗处方</el-button>
                      <el-button size="medium" @click="openPrescriptionTemplateDialog">处方模版</el-button>
                      <div class="prescription-btns_line"></div>
                      <el-button size="medium" icon="el-icon-present" @click="openComboSelect">活动</el-button>
                    </div>
                  </div>
                  <drug
                    ref="drugCom"
                    :type="type"
                    :consultationType="consultationType"
                    :drugOftenUsageList="drugOftenUsageList"
                    :editForm="editForm"
                    :patientForm="patientForm"
                    :drugItem.sync="drugItem"
                    :orderId="orderId"
                    :uniOrderNumber="uniOrderNumber"
                    :createTime="createTime"
                    :repeatVisitInfo="repeatVisitInfo"
                    :doctorInfo="doctorInfo"
                    :isOldYl="isOldYl"
                    :isDisabled="isDisabled"
                    :isEdit="isEdit"
                    @updateDrugItem="updateDrugItem"
                    @scrollTop="scrollTop"
                    @useRecipePhysioDemo="useRecipePhysioDemo"
                    @handlePrint="handlePrint">
                  </drug>
                  <combo
                    v-if="comboItem.length > 0"
                    :type="type"
                    :comboItem="comboItem"
                    @updataComboItem="updataComboItem"
                    :isDisabled="isDisabled"
                    :isEdit="isEdit">
                  </combo>
                  <physio
                    ref="physioCom"
                    v-if="physioItem.length > 0"
                    :type="type"
                    :isGroupOrder="isGroupOrder"
                    :consultationType="consultationType"
                    @handlePrint="handlePrint"
                    :physioItem.sync="physioItem"
                    @updataPhysioItem="updataPhysioItem"
                    :isDisabled="isDisabled"
                    :doctorId="doctorId"
                    :isEdit="isEdit">
                  </physio>
                  <chinese-medicine
                    ref="chineseMedicineCom"
                    v-if="chineseMedicineItem.length > 0"
                    :type="type"
                    :consultationType="consultationType"
                    @handlePrint="handlePrint"
                    :chineseMedicineItem.sync="chineseMedicineItem"
                    @updataChineseMedicineItem="updataChineseMedicineItem"
                    :isDisabled="isDisabled"
                    :isEdit="isEdit">
                  </chinese-medicine>
                </div>
                <div ref="scrollLink"></div>
                <div v-if="actList.length > 0" class="activity_section">
                  <ActivityProject ref="activityProject" :source="1" :deptId="deptId" :orderId="orderId" :actList="actList" :isEdit="isEdit" :isDisabled="isDisabled" @refreshOrder="refreshOrder"></ActivityProject>
                </div>
                <!-- 非处方项目 -->
                <div class="prescription-warp backfff mt14" ref="other">
                  <div class="prescription-top backfff">
                    <div class="prescription-title size14">非处方项目</div>
                  </div>
                  <OtherProject
                    :otherItem.sync="otherItem"
                    :type="type"
                    :isGroupOrder="isGroupOrder"
                    :consultationType="consultationType"
                    @updateOtherItem="updateOtherItem"
                    :isDisabled="isDisabled"
                    :isEdit="isEdit">
                  </OtherProject>
                </div>
                <!-- 医嘱模块 -->
                <div>
                  <div ref="adviceSection" class="prescription-advice backfff" :class="{ 'disabled': isDisabled }">
                    <div class="advice-title size14">医嘱事项</div>
                    <div class="advice-warp" ref="adviceTextarea">
                      <el-input id="adviceInput" :disabled="isDisabled" @focus="showAdvice" class="advice-textarea" autosize
                        type="textarea" v-model="editForm.doctorAdvice" @change="editCaseDiagnosis"
                        @input="editAdvice" />
                      <div ref="adviceSelect" v-if="adviceShow" class="advice-select">
                        <div class="adviceList">
                          <div :class="item.isSelect ? 'adviceList-item active' : 'adviceList-item'"
                            @click="selectAdvice(item.doctorAdviceTemplateId, index)"
                            v-for="(item, index) in adviceOption" :key="item.doctorAdviceTemplateId"
                            class="display-f just-b">
                            {{ item.content }}
                            <span v-if="item.isSelect" class="iconfont icon-gou color189 fwb size14"></span>
                          </div>
                        </div>
                        <div class="advice-bottom">
                          <div style="width:48%;" class="advice-close" @click="adviceShow = false">
                            <span class="iconfont icon-guanbi color189 mr5" style="font-size: 12px;"></span>
                            <span>关闭</span>
                          </div>
                          <div @click="setAdviceModal" class="color6671">
                            <span class="iconfont icon-a-Frame626727 color6671 mr5" style="font-size: 12px;"></span>
                            <span>设置模版</span>
                          </div>
                        </div>
                      </div>
                      <!-- <el-button @click="setAdviceModal">设置模版</el-button> -->
                    </div>
                  </div>
                  <div class="repeat-visit">
                    <div class="repeat-visit-content">
                      <div class="repeat-visit-true">
                        <el-checkbox
                          :disabled="isDisabled"
                          v-model="repeatVisitInfo.revisitFlag"
                          true-label="2"
                          @change="changeRepeatVisitHandle($event,'2')">
                        </el-checkbox>
                        <span>根据病情需要复诊</span>
                      </div>
                      <div class="repeat-visit-true">
                        <el-checkbox
                          :disabled="isDisabled"
                          v-model="repeatVisitInfo.revisitFlag"
                          true-label="1"
                          @change="changeRepeatVisitHandle($event,'1')">
                        </el-checkbox>
                        <span>请在</span>
                        <div class="date-content">
                          <div class="date-content-val" :class="{'gray': repeatVisitInfo.dateVal === '', 'disabled': isDisabled }">{{ repeatVisitInfo.dateVal || '日期' }}</div>
                          <div class="date-content-date">
                            <el-date-picker
                              v-if="!isDisabled"
                              v-model="repeatVisitInfo.dateVal"
                              style="width: 120px;opacity: 0"
                              type="date"
                              value-format="yyyy-MM-dd"
                              placeholder="选择日期"
                              :clearable="false"
                              :picker-options="repeatVisitInfo.pickerOptions"
                              @change="changeRepeatVisitDateHandle"
                            >
                            </el-date-picker>
                          </div>
                        </div>
                        <span>复诊</span>
                      </div>
                      <div class="repeat-visit-false">
                        <el-checkbox
                          :disabled="isDisabled"
                          v-model="repeatVisitInfo.revisitFlag"
                          true-label="0"
                          @change="changeRepeatVisitHandle($event,'0')">
                        </el-checkbox>
                        <span>无需复诊</span>
                      </div>
                    </div>
                    <div class="remark">
                      <el-popover
                        popper-class="diagnosePop remark"
                        placement="bottom-start"
                        width="300"
                        trigger="manual"
                        v-model="repeatVisitInfo.remarkInfo.showRemark"
                      >
                        <div class="list">
                          <div class="list-item" v-for="item in repeatVisitInfo.remarkInfo.remarkList" @click="setRemarkHandle(item)">{{ item }}</div>
                        </div>
                        <input
                          slot="reference"
                          type="text"
                          class="remark-input"
                          v-model="repeatVisitInfo.remarkInfo.remark"
                          maxlength="100"
                          placeholder="复诊备注"
                          :disabled="isDisabled"
                          @input="inputRemarkHandle"
                          @click.stop="searchRemarkHandle"
                        />
                      </el-popover>
                    </div>
                  </div>
                </div>
                <!-- 操作记录 -->
                <div class="handleHistory" v-if="getHandleHistoryList.length > 0">
                  <div class="color1890 size14" @click="showHandleList = !showHandleList">
                    操作记录<i :class="showHandleList ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
                  </div>
                  <div v-if="showHandleList">
                    <div v-for="item in getHandleHistoryList" :key="item.finishCaseRecordId"
                      class="size12 color6671 mt6">
                      <span class="mr16">{{ item.finishTime }}</span><span class="mr16">{{ item.createBy }}</span><span class="mr16">{{ caseTypeObj[item.caseType] }}</span>
                    </div>
                  </div>
                </div>
                <div class="content_reserve"></div>
              </div>
            </div>
          </div>
          <div v-if="!orderId" class="w100_ tac color9AA0 size14" style="margin-top: 160px;">暂无门诊记录</div>
        </div>

        <ComboSelect ref="comboSelect" :doctorId="doctorId" :source="1" @submit="submitComboSelect"></ComboSelect>

        <el-dialog
          title="请选择转诊医生"
          :visible.sync="referralMap.show"
          class="referral_dialog"
          width="340px"
          :before-close="referralClose">
          <div></div>
          <div class="referral_content">
              <el-form ref="referralForm" :model="referralMap.form" :rules="referralMap.rules" label-width="70px">
                  <el-form-item label="转诊给" prop="doctorId">
                      <el-select v-model="referralMap.form.doctorId" placeholder="选择转诊医生">
                          <el-option v-for="item in chooseLeftPatientInfo.referralDoctorList" :key="item.doctorId" :label="item.doctorName" :value="item.doctorId"></el-option>
                      </el-select>
                  </el-form-item>
              </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
              <el-button @click="referralClose">取 消</el-button>
              <el-button type="primary" @click="referralConfirm">确 定</el-button>
          </div>
      </el-dialog>

      </div>

      <div slot="right" class="newDiagnosis-right w100_" style="  height: 100%;">
        <div class="right-title display-f tac borderBox">
          <div v-if="consultationType === 2" @click="rightTab = 2; initChatRoom()" :class="{ normalTabs: true, activeTabs: rightTab == 2 }">聊天室</div>
          <div @click="rightTab = 1" :class="{ normalTabs: true, activeTabs: rightTab == 1 }">历史诊断<span class="color6671 size12">{{ historyTotal < 100 ? historyTotal : '99+' }}</span></div>
          <div @click="rightTab = 4" :class="{ normalTabs: true, activeTabs: rightTab == 4 }">理疗信息<span class="color6671 size12">{{ physioAssetTotal < 100 ? physioAssetTotal : '99+' }}</span></div>
        </div>
        <div v-if="rightTab == 1" class="right-content" v-loadMore="getMoreHisList">
          <HistoryDiagnosis
            :doctorId="doctorId"
            :editForm="editForm"
            :patientForm="patientForm"
            :isEdit="isEdit"
            :isHelper="isHelper"
            :isDisabled="isDisabled"
            :isGroupOrder="isGroupOrder"
            :historyList="historyList"
            :orderId="orderId"
            @getOutPatientAll="getOutPatientAll">
          </HistoryDiagnosis>
        </div>
        <div v-if="rightTab == 2" class="right-content">
          <ChatRoom
            ref="chatRoom"
            @onlineInfoUpdate="onlineInfoUpdate">
          </ChatRoom>
        </div>
        <div v-if="rightTab == 4" class="right-content">
          <physio-asset
            :physioAssetList="physioAssetList">
          </physio-asset>
        </div>  
      </div>
    </leftCenterRightContainer>
    <OldCustomDialog :title="dialogTitle" :showFooter="false" :dialogWidth="dialogWidth" v-if="dialogShow"
      :visible.sync="dialogShow" :before-close="closeDialog">
      <component ref="component" :is="componentName" @localUpload="localUpload" @cancel="closeDialog"
        :drugItem="drugItem" :comboItem="comboItem" :chineseMedicineItem="chineseMedicineItem" :physioItem="physioItem" @userCombo="userCombo"
        :otherItem="otherItem" :actList="actList" @recipeInfoBack="recipeInfoBack" :doctorInfo="doctorInfo" :patientForm="patientForm"
        :orderId="orderId" :registerPrice="isRegister.price" :effectsDrugs="effectsDrugs" :excessDrugs="excessDrugs" :source='1'
        @doctorSign="doctorSign" @uploadCompany="uploadCompany">
      </component>
    </OldCustomDialog>

    <addPatient :visibleObj="visiblePatientObj" @addPatientComfirm="addPatientComfirm" :addPatientType="addPatientType"
      :patientInfo="patientForm" @close="close" :title="patientDialogTitle"></addPatient>
    <custom-dialog class="deleteAll" title="删除确认" width="370px" v-if="visiblePatientObj.deleteAllDiagnosisDialog"
      :show-close="true" :visible="visiblePatientObj.deleteAllDiagnosisDialog"
      @close="dialogVisibleClose('deleteAllDiagnosisDialog')" @save="deleteAllDia">
      <div slot="content">删除后不可恢复，确定删除该草稿？</div>
    </custom-dialog>
    <!-- 打印 -->
    <printDialog :printDialogShow="printDialogShow" v-show="printDialogShow"
      @closePrintPrescription="closePrintPrescription" ref="printDia" @setPrintDiaShow="setPrintDiaShow"
      @printSuccess="printSuccess" :isBatch="isBatch" :printListObj="printListObj" :id="printOrderId"
      :orderType="printorderType" :printType="printType" @printSuccessBatch="printSuccessBatch">
    </printDialog>
    <!-- 库存不足/停售/理疗禁用弹框 -->
    <inventory-tips-dialog type='diagnos'
      @savePrescription="(type  == '3' || type == '8') ?saveDoor('1', true,false):savePrescription('1', true,false)"
      @closeInventoryTipsDialog="inventoryTipsDialogShow = false" :inventoryTipsDialogShow="inventoryTipsDialogShow"
      :drugList="drugList">
    </inventory-tips-dialog>
    <!-- 再次挂号弹框 -->
    <register-dialog :dialogObj="registerObj" v-if="registerObj.show" @closeRegister="closeRegister"></register-dialog>
  </div>
</template>

<script>
import { meetDiagnose, historyList,queryRecentlyCase,getDoctorPatientSummary,updateSummaryFlag } from "@/api/history"; // 病历请求
import drug from './drug/index'
import physio from './physio/index'
import OtherProject from './otherProject/index.vue'
import ActivityProject from './activityProject/ActivityProject.vue'
import OldCustomDialog from '@/components/customDialog/index.vue';
import printDialog from '@/components/printDialog'
import customDialog from '@/components/customDialog/CustomDialog.vue'
import uploadDialog from './uploadDialog/index'
import { patientInfom } from "@/api/patient"; // 病人列表请求
import { validatePhone, validateName, validateYear, validateMonth } from "@/utils/regexp" // 自定义验证
import { isNull, deepClone, isEmptyArray, isObject, debounce, msgboxWarning, isNullObj, delSomeObjValue, dictText, isArray,getContentBetween,getSpanData,uniqueArray } from '@/utils/validateBase'
import { webChatDetails } from "@/api/webchat" // 网诊模块请求
import { doctorList, doctorInfo, getPreRegisPrice, getRevisitRegisterPrice } from '@/api/doctor'
import { Utils } from '@/utils/utils'
import comboDialog from './comboDialog/index'
import combo from './combo/index'
import { adviceList } from "@/api/advice"; // 医嘱请求
import prescriptionTemplateDialog from './prescriptionTemplateDialog/index'
import { getAccountPhysioProperty } from '@/api/physio'
import adviceDialog from './adviceDialog/index'
import { uploadTemporaryFile } from "@/api/post"; // 科室请求
import costPreview from './costPreview/index'
import addPatient from "@/components/addPatient.vue";
import effects from './effects/index'
import leftCenterRightContainer from "@/components/leftCenterRightContainer.vue";
import ChatRoom from './component/ChatRoom.vue';
import MedicalInsuranceDiagnosis from "@/components/MedicalInsuranceDiagnosis.vue";
import CustomForm from "@/components/CustomForm.vue";
import OutPatientLeft from "./outPatientLeft/index.vue";
import HistoryDiagnosis from './historyDiagnosis/index.vue'
import { Outpatient, Common, Patient } from './data/index.js'
import { visibleObj } from '@/components/js/dialog';
import { CommonDTO, patientDTO, prescriptionDTO } from '@/DTO/index'
import inventoryTipsDialog from '@/components/inventoryTipsDialog/inventoryTipsDialog';
import Upload from "@/components/Upload/Upload";
import { doctorVisitDict, sexDict, doseOptions,productRechargeList,testRechargeList } from '@/utils/const'
import chineseMedicine from './chineseMedicine/index'
import Menstruation from '@/components/Menstruation'
import registerDialog from './registerDialog/index.vue'
import { touchPoint } from '@/api/common'
import { imgArr } from '@/assets/images/img'
import voiceDialog from './component/voiceDialog'
import AIDiagnosisDialog from './component/AIDiagnosisDialog'
import PreConsultationHelper from './component/PreConsultationHelper.vue'
import { getVersion } from '@/api/voice'
import PresentCondition from '@/components/PresentCondition'
import PreviousHistory from '@/components/PreviousHistory'
import AllergyHistory from '@/components/AllergyHistory'
import physioAsset from './physioAsset/physioAsset'
import assistantRemark from './component/assistantRemark'
import ComboSelect from '@/components/campaign/comboSelect.vue'
import { getTeamReferralDoctorList, setOrderReferral } from '@/api/studio'
import { postCombSaleSelect } from '@/api/campaign'
import { helper } from "echarts";
import req from '@/utils/request'
export default {
  components: {
    customDialog,
    OldCustomDialog,
    uploadDialog,
    drug,
    comboDialog,
    combo,
    physio,
    ActivityProject,
    prescriptionTemplateDialog,
    adviceDialog,
    costPreview,
    addPatient, 
    effects,
    leftCenterRightContainer,
    ChatRoom,
    MedicalInsuranceDiagnosis,
    CustomForm,
    OutPatientLeft,
    HistoryDiagnosis,
    OtherProject,
    printDialog,
    inventoryTipsDialog,
    Upload,
    chineseMedicine,
    Menstruation,
    registerDialog,
    voiceDialog,
    AIDiagnosisDialog,
    PreConsultationHelper,
    PresentCondition,
    PreviousHistory,
    AllergyHistory,
    physioAsset,
    assistantRemark,
    ComboSelect
  },
  data() {
    return {
      imgArr:imgArr,
      preConsultationHelperVisible: false,
      loading: false,//加载动画
      patientFormLoading: false, //患者搜索下拉loading
      consultationType: 1,
      orderId: '', // 挂号id
      webChatOrderInfoId: '',
      uniOrderNumber: '',
      createTime: '',
      type: '', //type 1 快捷开方 2 诊断开方 3 查看
      isGroupOrder: false,//是否是三方订单
      isDisabled: false,//是否禁用
      judgeDisabled: false,
      editFormRules: {
        patientName: [{ required: true, validator: validateName, trigger: 'blur' }],
        phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        // sex: [{ required: true, message: '请选择患者性别', trigger: 'change' }],
        year: [{ required: false, validator: validateYear, trigger: 'blur' }],
        month: [{ required: false, validator: validateMonth, trigger: 'blur' }]
      },
      patientForm: {
        patientName: "",
        sex: '0',
        year: "",
        month: "",
        phone: "",
        doctorVisit: "0"
      }, //患者对象
      patientList: [],
      doctorList: [], //医生列表
      editForm: {
        // diagnosIds: [],
        dialectical: null,
        patientTell: null,
        previousHistory: null,
        imgs: [],
        doctorAdvice: '',//选择的医嘱
        price: null,
        registerPrice: null,
        // type: '',
        diagnosisList: [],
        presentCondition: null,//现病史
        facePalpation: null,//望闻切诊
        menstrualHistory:'',//月经史
        accessoryExamination:'',//辅助检查
        preNotes:''
      },
      doctorInfo: {}, // 医生信息
      doctorId: '', //医生id
      showDoctorInfo: false, // 是否显示医生信息popover
      popoverStyle: {}, // popover位置样式
      orderPayFlag: "0",//支付状态
      dialogTitle: '',//弹框标题
      componentName: '',//弹框组件
      dialogShow: false,//弹框显示
      dialogWidth: '450px',//弹框宽度
      attachmentShow: false,//是否显示附件
      diagnosisList: [],//诊断列表
      diagnosIds: [],
      uploadUrl: this.$filePath + '/xl/upload/temp/file/upload', // 图片上传接口地址
      drugItem: [],//中药处方列表
      physioItem: [],//理疗处方列表
      otherItem: {},//非处方项目列表
      chineseMedicineItem: [],//非处方项目列表
      comboItem: [],//隐秘处方列表
      adviceShow: false,//医嘱下拉框显示
      adviceSelectList: [],//选中的医嘱id
      chooseAdviceList: [],//选中的医嘱
      adviceOption: [],//所有医嘱列表
      historyList: [], // 病历列表
      historyTotal: 0,//历史病例总数
      historyPageNum: 1,//历史病例页码
      drugPrice: [], // 中药处方价格
      physioPrice: [], // 理疗处方价格
      comboPrice: [], // 隐秘处方价格
      drugPriceArr: [], // 中药处方价格
      physioPriceArr: [], // 理疗处方价格
      comboPriceArr: [], // 隐秘处方价格
      fileList: [], // 图片列表
      dialogImageUrl: null, // 图片模态框图片地址
      dialogVisible: false,
      addPatientShow: false,
      editOrderData: {},//挂单数据
      orderStatus: null,//订单来源 0挂号单  1快捷
      effectsDrugs: [], // 相反、相畏
      excessDrugs: [], // 超量数组
      names: [], // 所有相反、相畏、超量药品名字
      rightTab: 1,//1 历史记录 2 网诊聊天室 3 问诊单
      webChatOrderInfoId: this.$route.query.webChatOrderInfoId, // 网诊id
      tableHeight: 0, // 表格最大高度
      patientId: this.$route.query.patientId || null, // 患者id
      webChatInfo: {
        patientName: null,
        sex: '0',
        year: null,
        month: null,
        phone: null,
        doctorVisit: null,
        doctorName: null
      }, // 网诊对象
      isConflict: false,//页面是否冲突
      preImage: [],//预览图片list
      chooseLeftPatientInfo: {},//点击左边患者信息，
      isRegister: {//是否是挂号患者
        price: null,//快捷开方价格
        registeredPrice: null,//正常挂号
      },
      deptId: this.$session.get('deptId'),
      isInputInvalid: false,//主诉和诊断是否填写
      isInputInvalidDia: false,
      isInputInvalidPresentCondition: false,
      isInputInvalidPreviousHistory: false,
      isInputInvalidFacePalpation: false,
      visiblePatientObj: visibleObj,//新增患者
      hasMoreHistoryList: true,//是否还有更多历史数据
      historyTotalPage: 1,//历史数据最多加载多少页
      patientDialogTitle: '新增患者',//新增患者弹框
      addPatientType: '',
      isDoctor: true,//是否是医生
      isHelper: false,//是否是医助
      preExamineFlag: null,
      getHandleHistoryList: [],//c操作记录
      showHandleList: false,//是否展示操作记录
      isBatch: false,//是否批量打印
      recipesList: [],//所有的处方
      actList: [],//套餐列表
      printDialogShow: false,//打印弹框
      printListObj: [],//批量打印列表
      printorderType: '',//打印处方订单类型 0挂号 1中药 2理疗 3隐秘 4划价单
      printType: '',///打印类型 1小票 2处方
      isEdit: false,//是否是修改
      caseTypeObj: {
        '0': '提交预诊',
        '1': '完成接诊',
        '2': '修改预诊',
        '3': '修改诊断',
        '4': '修改附件'
      },
      inventoryTipsDialogShow: false,//库存不足弹框
      drugList: [],//所有药品列表
      caseList: [],//病例列表
      defaultCaseList: [],//默认选择的病历列表
      preCaseList: [],//当前用户设置的列表
      chooseCaseList: ['patientTell', 'presentCondition', 'previousHistory', 'facePalpation', 'diagnosis', 'dialectical'],//选择的病历列表
      showCase: false,
      registerResp: {},//预计就诊时间
      uploading: false,
      isOldYl: false,//是否是老医联产品
      adviceLength: 0,//医嘱长度
      printOrderId: '',
      diagnosObj: {
        diagnosName: '',//诊断 input展示值
        diagnosVisible: false,//诊断，选择列表展示
        activeIndex: 0,
        operateIndex: -1,
        isFocus: false
      },
      doctorVisitDict: doctorVisitDict,//初诊还是复诊
      sexDict: sexDict,//性别
      needUpdateDia:false,
      drugOftenUsageList: [],
      imgIndex:0,
      menstruationShow:false,// 月经史弹框
      menstrualHistoryHtml:'',//月经史渲染变量
      menstrualHistory:[],
      registerObj:{
        show:false,
        patientInfo:{},
        doctorInfo:{}
      },
      // 复诊
      repeatVisitInfo: {
        revisitFlag:'',
        dateVal: '',
        remarkInfo: {
          showRemark: false,
          remark: '', // 复诊备注
          remarkList: ['若症状痊愈，则无需复诊'],
          remarkResultList: [],
        },
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < (Date.now() - 3600 * 1000 * 24)
          },
          shortcuts: [{
            text: '三天后',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 3)
              picker.$emit('pick', date)
            }
          }, {
            text: '一周后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }, {
            text: '两周后',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 14)
              picker.$emit('pick', date)
            }
          }, {
            text: '三周后',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 21)
              picker.$emit('pick', date)
            }
          }, {
            text: '30天后',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30)
              picker.$emit('pick', date)
            }
          }, {
            text: '90天后',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 90)
              picker.$emit('pick', date)
            }
          }]
        },
      },
      chargePotential:null,//充值潜力对象
      voiceObj:{
         recordShow:false,
         diagnosisShow:false,
         diagnosisParams:{}
      },
      isDragging: false,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
      boxStyle: {
        left: 'calc(100% - 340px - 320px)',
        top: '165px'
      },
      presentConditionShow:false,
      previousHistoryShow:false,
      allergyHistoryShow:false,
      physioAssetList:[],
      physioAssetTotal:null,
      assistantRemarkShow:false,
      roles:[],
      isHidden:false,
      referralMap: {
        show: false,
        form: {
          doctorId: ''
        },
        rules: {
          doctorId: [{ required: true, message: '请选择转诊医生', trigger: 'change' }]
        }
      },
      doctorPatientSummary: null,
    }
  },
  //变量监听
  watch: {
    'patientForm.patientId'(val) {
      if (isNull(val)) {
        this.patientForm.sex = ''
        this.patientForm.year = ''
        this.patientForm.month = ''
        this.patientForm.phone = ''
        this.patientForm.visit = ''
      }
      // this.getHistoryList()
    },
    // 监听路由参数改变
    '$route'(to, from) {
      let { page, flag, orderId, webChatOrderInfoId } = this.$route.query;
      if (this.doctorId) this.initData(page, orderId, webChatOrderInfoId);
      this.page = page;
      this.flag = flag;
      this.orderId = orderId;
      this.webChatOrderInfoId = webChatOrderInfoId;
    },
  },
  filters:{
    filterSex(val, sexDict) { return isNull(val) ? '' : dictText(val, sexDict) },
    
  },
  computed: {
    computeTotalPrice1() {
      let that = this
      return function (drug, phy,chineseMedicineItem, other, actList) {
        if (that.orderStatus == '1' || that.orderStatus == '2') {
          return Common.computeTotalPrice(drug, phy, chineseMedicineItem, other, actList, that.isRegister.price)
        } else {
          return Common.computeTotalPrice(drug, phy, chineseMedicineItem, other, actList)
        }
      }
    },
    computedCaseName() {
      let that = this;
      return function (val) {
        let list = that.caseList;
        if (isNull(list) || !isArray(list) || isEmptyArray(list)) {
          return val
        }
        for (let i = 0; i < list.length; i++) {
          if (list[i].propertyName == val) {
            return list[i].displayName
          }
        }
      }
    },
    filterMenstrual(){ 
      return function(val){
        let str = ''
        if(!isEmptyArray(val)){
          if(val.length==1){
              str = val[0]
          }else if(val.length==2){
              str = `${val[0]}~${val[1]}`
          }
        }
        return str;
      }
     },
     computedPerUnitCount() {
      return function (physioExtendJson) {
        let num = 0
        let { acupointinfoList, perUnit } = physioExtendJson
        if (isNull(perUnit)) {
          acupointinfoList.forEach(v => {
            if(v.type == 60){
              num = num + Number((isNull(v.typeExtend) ? 0 :v.typeExtend.length))
            }else if(v.type == 50){
              num =  num + Number((isNull(v.typeExtend) ? 0 : v.typeExtend[0]))
            }else if(v.type == 20){
              num = num + 2;
            }else{
              num = num + 1
            }
          })
        } else {
          acupointinfoList.forEach(v => {
            if (v.speciesType == perUnit) {
              if(v.type == 60){
              num = num + Number((isNull(v.typeExtend) ? 0 :v.typeExtend.length))
              }else if(v.type == 50){
                num =  num + Number((isNull(v.typeExtend) ? 0 : v.typeExtend[0]))
              }else if(v.type == 20){
                num = num + 2;
              }else{
                num = num + 1
              }
            }
          })
        }
        return num
      }
    },
    computeYbScope(){
      return function(val){ 
        if(val == 1){
          return '可统筹'
        }else if(val == 2){
          return '仅个账'
        }else{
          return '不可刷医保'
        }
      }
    },
    computedOrderYbScope(){
      return function(list){
        let str = ''
        if(!isEmptyArray(list)){
          if(list.findIndex(v=>{ return isNull(v.ybScope) || isNull(v.diagnoseCode) || v.ybScope == 3  }) > -1){
            str = '不可刷医保'
          }else if(list.findIndex(v=>{ return v.ybScope == 2  }) > -1){
            str = '仅个账'
          }else if(list.every(v=>{ return v.ybScope == 1  })){
            str = '可统筹'
          }
        }
        return str
      }
    }
  },
  async created() {
    this.roles = this.$session.get('roles')
    let doctorId = this.$session.get('user').doctorId
    let type = this.$session.get('user').type
    this.doctorId = doctorId
    if (type === '0') {
      this.getDoctorInfo()
    } else {
      this.isDoctor = false
    }
    if (type == '1') {
      this.isHelper = true;
    }
    //获取所有的病例字段
    this.getAllCaseList()
    this.getOftenUsage()
  },
  // 页面DOM加载完成
  mounted() {
    // 在挂载时将事件监听器添加到文档上
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    // 在卸载组件之前删除事件监听器
    document.removeEventListener("click", this.handleClickOutside);
    this.$message.closeAll()
  },
  methods: {
    consultationTypeChange (val) {
      this.consultationType = val
    },
    //获取病历字段
    async getAllCaseList() {
      //获取所有病历字段列表
      let res = await patientDTO.getCaseFieldAll()
      if (res.code == 200) {
        this.caseList = res.data || []
      }
      this.getCaseFieldList()

    },
    // 获取医生常用用法
    async getOftenUsage() {
      const oftenUsage = await Outpatient.getOftenUsage()
      this.drugOftenUsageList = oftenUsage || []
    },
    async getCaseFieldList() {
      //获取当前登录人病历字段列表
      let listRes = await patientDTO.getCaseField()
      if (listRes.code == 200) {
        if (_.isEmpty(listRes.data)) return;
        this.preCaseList = listRes.data
        this.chooseCaseList = listRes.data.map(v => v.propertyName)
      }
    },
    getDoctorInfo() {
      this.getDoctorDetail(this.doctorId)
      this.getAdviceList()
    },
    toggleDoctorInfo() {
      this.showDoctorInfo = !this.showDoctorInfo
      if (this.showDoctorInfo) {
        this.$nextTick(() => {
          this.updatePopoverPosition()
        })
      }
    },
    updatePopoverPosition() {
      const wrapper = this.$refs.doctorPopoverWrapper
      if (wrapper) {
        const rect = wrapper.getBoundingClientRect()
        this.popoverStyle = {
          left: rect.left + 'px',
          top: (rect.top - 85) + 'px'
        }
      }
    },
    checkAllDisable() {
      let disStatus = ['3', '8', '9'];//需要禁用的状态
      if (disStatus.includes(this.type) || this.orderPayFlag == '1' || (this.isHelper && this.preExamineFlag == '1')) this.isDisabled = true;
      if (disStatus.includes(this.type) || this.orderStatus == '0' || this.orderPayFlag == '1' || this.preExamineFlag == '1') {
        this.judgeDisabled = true;
      } else {
        this.judgeDisabled = false;
      }
      //判断展示的病历列表
      // if (this.type == 4 || this.orderPayFlag == '1') {
      //   this.chooseCaseList = this.caseList.map(v => v.propertyName)
      // } else {
      // }
      this.chooseCaseList = this.preCaseList.map(v => v.propertyName)
    },
    //医生选择左边患者
    async choosePatient(info) {
      const data = info.order
      if (['-6', '2'].includes(data.status)) {
        if (this.isHelper) {
          if (data.preExamineFlag === '0') {
            window.$trackTool.track({ v: '1', b: 'his_000003', t: 'his_0001' }, { updateTime: new Date().Format('yyyy-MM-dd hh:mm:ss'), orderId: data.orderId })
          }
        } else {
          window.$trackTool.track({ v: '1', b: 'his_000005', t: 'his_0001' }, { updateTime: new Date().Format('yyyy-MM-dd hh:mm:ss'), orderId: data.orderId })
        }
      }

      info['referralDoctorList'] = []

      if (['1', '2'].includes(info.order.status)) {
        let referralRes = await getTeamReferralDoctorList({ doctorId: info.doctor.doctorId })
        if (referralRes.code == 200) {
          info.referralDoctorList = referralRes.data.filter(v => { return v.doctorId && v.doctorId != info.doctor.doctorId }) || []
        }
      }

      try {
        this.clearInfo();//清除上一个患者页面编辑内容
        this.resetHistoryParam()
        this.chooseLeftPatientInfo = info
        this.orderId = info.order.orderId
        this.webChatOrderInfoId = info.order.webChatOrderInfoId
        this.uniOrderNumber = info.order.uniOrderNumber
        this.createTime = new Date(info.order.createTime).Format('yyyy-MM-dd hh:mm:ss')
        this.orderPayFlag = info.order.orderPayFlag
        this.orderStatus = info.order.orderSourceType;//订单来源
        this.type = info.order.status;//订单状态
        this.isGroupOrder = info.order.isGroupOrder || false;
        this.preExamineFlag = info.order.preExamineFlag;//是否预诊
        if (!this.isDoctor) {
          this.doctorId = info.doctor.doctorId
          this.getDoctorInfo()
        }
        this.checkAllDisable()
        if (info.patient && info.patient.patientId) {
          this.isRegister.registeredPrice = info.doctor.registeredPrice//挂号费
          this.patientForm = info.patient;
          this.patientForm.year = info.patient.age;
          this.patientForm.month = info.patient.ageMth;
          //获取初诊还是复诊
          this.getDoctorVisit()
          //获取是否开过方
          this.getOutPatientAll(info.order.orderId, 1)
        }
        if ((this.orderStatus == '1' || this.orderStatus == '2') && info.patient && info.patient.patientId) {
          this.isRegister.price = info.doctor.registeredPrice
        } else if (this.orderStatus == '1' && !info.patient) {//快捷开方
          this.isRegister.registeredPrice = null
          this.isRegister.price = await Common.getDoctorRegisPrice({ doctorId: this.doctorId })
          this.$nextTick(() => {
            this.$refs.selectPatient.$el.querySelector('.el-input__inner').focus()
          })
        }
        // 复诊
        // 第一步判断是否随访 0是 1否
        this.repeatVisitInfo.revisitFlag = isNull(info.order.revisitFlag) ? '2' : info.order.revisitFlag 
        
        // 赋值日期
        this.repeatVisitInfo.dateVal = this.repeatVisitInfo.revisitFlag == '1' ? (info.order.revisitTime || '') : ''
        this.repeatVisitInfo.remarkInfo.remark = info.order.revisitNotes || ''
        
        //验证是否已经选择患者
        this.checkPatientInfo()
        this.getHandleHistory()
        if (this.consultationType === 2) {
          this.$nextTick(() => {
            this.$refs['chatRoom'].init(this.orderId)
          })
        }
        this.getDoctorPatientSummary()
      } catch (error) {
        this.loading=false;
      }
      
    },
    initChatRoom () {
      if (this.orderId) {
        this.$nextTick(() => {
          this.$refs['chatRoom'].init(this.orderId)
        })
      }
    },
    //获取门诊中间部分信息
    getOutPatientAll(orderId, num) {
      if (num) {
        this.getHistoryList()
        this.getPhysioProperty()
      }
      return Outpatient.outPatientAll({ orderId }).then(res => {
        const { isNewCase, isNewProject, data } = res;
        //计算是否是老医联产品
        this.isOldYl = CommonDTO.handleOldData(data.orderDetail.order.createTime)
        //病历上预计就诊时间
        this.registerResp = data.registerResp
        if (!isNewCase) {//编辑过病历，将病历渲染到页面上
          this.handleCase(data)
        }else{
          //病历为空，则查询最近病历填上
          queryRecentlyCase({patientName: this.patientForm.patientName,patientPhone: this.patientForm.phone}).then(res=>{
            if(res.code == 200 && res.data){
              this.editForm.presentCondition = res.data.presentCondition || ''
              this.editForm.previousHistory = res.data.previousHistory || ''
              this.editForm.allergyHistory = res.data.allergyHistory || ''
              this.editForm.menstrualHistory = res.data.menstrualHistory || ''
              this.menstrualHistoryHtml  = isNull(res.data.menstrualHistory) ? '' : this.handleMenstrualHistoryHtml(JSON.parse(res.data.menstrualHistory))
            }
          })
        }
        
        this.recipesList = data.projectRecipes
        let drugItem = data.projectRecipes.filter(val => val.projectType == 0 && val.recipeType == 1)
        drugItem.forEach((val, ind) => {
          val.isOldYl = this.isOldYl
          this.addSearch(val.items, 'drug',val.doseType)
        })
        this.$set(this, 'drugItem', drugItem)
        this.$nextTick(() => {
          let drugDom = this.$refs.drugCom;
          drugDom && drugDom.addMethod()

        })
        this.physioItem = data.projectRecipes.filter(val => val.projectType == 0 && val.recipeType == 3)
        this.physioItem.forEach(val => {
          this.addSearch(val.items, 'physio')
        })
        this.chineseMedicineItem = data.projectRecipes.filter(val => val.projectType == 0 && val.recipeType == 4)
        this.chineseMedicineItem.forEach(val => {
          this.addSearch(val.items, 'chinsesMedicine')
        })
        let otherItems = data.projectRecipes.filter(val => val.projectType == 1 && val.recipeType == 0)
        if (_.isEmpty(otherItems)) {
          this.otherItem = {
            orderId: this.orderId,
            projectType: '1',
            recipeType: '0',
            items: [
              {
                itemId: '',
                itemName: ''
              }
            ]
          }
        } else {
          this.otherItem = otherItems[0]
          this.addSearch(this.otherItem.items, 'other')
        }

        this.actList = data.actGroups && data.actGroups.map(v => {
          v.items && v.items.map(act => {
            if (act.physioExtendJson) {
              act.physioExtendJson.acupointinfoList = act.physioExtendJson.acupointinfoList || []
            }
          })
          return v
        }) || []

        if(this.isDisabled){
          this.getChargePotential()
        }
        if(data.orderDetail.order.summaryFlag =='0' && this.doctorInfo.confidant == '1'){
          // 弹出诊前知己弹窗
          this.preConsultationHelperVisible = true
          updateSummaryFlag({ orderId: this.orderId,summaryFlag: '1'}).then(res=>{})
          window.$trackTool.track({ v: '1', b: 'his_000010', t: 'his_0003' }, { updateTime: new Date().Format('yyyy-MM-dd hh:mm:ss'), orderId: this.orderId,doctorId: this.doctorId })
        }
      })
    },
    getCase() {
      Outpatient.caseDiagnosis({ orderId: this.orderId }).then(res => {
        this.handleCase({ orderCaseDiagnosis: res.data })
      })
    },
    handleCase(data) {
      this.editForm = data.orderCaseDiagnosis;
      if(!isNull(data.orderCaseDiagnosis.menstrualHistory)){
        this.menstrualHistoryHtml  = this.handleMenstrualHistoryHtml(JSON.parse(data.orderCaseDiagnosis.menstrualHistory))
      }
      if (!_.isEmpty(data.orderCaseDiagnosis.images)) {
        this.editForm.imgs = data.orderCaseDiagnosis.images.split(',');
        // this.fileList = this.editForm.imgs.map((item, i) => {
        //   return { name: "img" + i, url: item }
        // })
        // this.fileList = this.editForm.imgs || []
      } else {
        this.editForm.imgs = []
      }
      let formatDiagnosis = data.orderCaseDiagnosis.diagnosisList.map(val => { return { code: val.diagnoseCode, name: val.diagnoseName,ybScope: val.ybScope } })
      this.diagnosIds = formatDiagnosis;
      this.diagnosisList = formatDiagnosis
      let diaArr=data.orderCaseDiagnosis.diagnosisList
      if(!_.isEmpty(diaArr)){
       let name= diaArr.map(v=>v.diagnoseName).join(';');
       this.diagnosObj.diagnosName=name || ''
      }
      this.editForm.diagnosisList = data.orderCaseDiagnosis.diagnosisList
      // console.log('this.editForm.diagnosisList ',this.editForm.diagnosisList );
      if (!isNull(data.orderCaseDiagnosis.doctorAdvice)) {
        this.chooseAdviceList=[]
        //处理复制的医嘱
        let arr = data.orderCaseDiagnosis.doctorAdvice.split('\n')
        if (_.isEmpty(arr)) return
        arr && arr.map(v => {
          this.chooseAdviceList.push(
            {
              content: v,
              delFlag: "0",
              doctorAdviceTemplateId: 'own0'

            }
          )
        })
        // this.chooseAdviceList = [{
        //   content: data.orderCaseDiagnosis.doctorAdvice,
        //   delFlag: "0",
        //   doctorAdviceTemplateId: 'own0'

        // }]
        this.handleAdvice()
      }
    },
    //编辑病历模块数据
    editCaseDiagnosis: _.debounce(function () {
      if (this.isDisabled) return;
      //处理需要传入对象
      let caseDiagnosis = _.cloneDeep(this.editForm);
      let chooseCase = _.cloneDeep(this.chooseCaseList);//选择的诊断
      let caseList = _.cloneDeep(this.caseList);
      let allCase = caseList.map(v => v.propertyName);
      let deleteCase = _.difference(allCase, chooseCase);//需要置空的case
      deleteCase.forEach(k => {
        caseDiagnosis[k] = ''
      })
      let obj = {
        orderId: this.orderId,
        ...caseDiagnosis,
        images: _.toString(caseDiagnosis.imgs),
        revisitFlag: this.repeatVisitInfo.revisitFlag,
        revisitTime: this.repeatVisitInfo.dateVal || '',
        revisitNotes: this.repeatVisitInfo.remarkInfo.remark || ''
      }
      delete obj.imgs
      if (this.isEdit) return
      Outpatient.editCaseDiagnosis(obj).then(res => {

      })
    }, 300),
    //快捷开方保存患者信息
    savePatient(num) {
      if (this.isRegister.price == 0) {
        this.isRegister.price = _.toString(this.isRegister.price)
      }
      let obj = {
        orderId: this.orderId,
        deptId: this.deptId,
        orderType: '0',
        patientId: this.patientForm.patientId,
        price: this.isRegister.price || this.isRegister.registeredPrice,
        doctorId: this.doctorId,
      }
      if (!obj.price) obj.price = '0';
      if (this.orderPayFlag == '1') {//如果已经收费修改患者信息就只更新列表不在保存其他信息
        this.$refs['outpatientLeft'].getOutlineList(2);
        return
      }
      Patient.savePatientInfo(obj).then(res => {
        if (res.code == 200) {
          if (!num) {
            this.checkPatientInfo()
          }
          this.$refs['outpatientLeft'].getOutlineList(2)
        }
      })
      this.getOutPatientAll(this.orderId, 1)
    },
    //获取患者是初诊还是复诊
    getDoctorVisit() {
      let obj = {
        patientId: this.patientForm.patientId,
        doctorId: this.doctorId,
        orderId: this.orderId
      }
      Patient.getDoctorVisit(obj).then(res => {
        this.patientForm.doctorVisit = res.data
      })
    },
    //验证是否填写患者信息
    checkPatientInfo() {
      if (!this.patientForm.patientId || (this.type == '3' || this.type == '8' || this.type == '9' || this.orderPayFlag == '1') || (this.isHelper && this.preExamineFlag == '1')) {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
    },
    //验证主诉
    validatePatientTell() {
      if (isNull(this.editForm.patientTell)) {
        this.isInputInvalid = true
      } else {
        this.isInputInvalid = false
      }
      if (isNull(this.editForm.facePalpation)) {
        this.isInputInvalidFacePalpation = true
      } else {
        this.isInputInvalidFacePalpation = false
      }
    },
    validatePresentCondition() {
      if (isNull(this.editForm.presentCondition)) {
        this.isInputInvalidPresentCondition = true
      } else {
        this.isInputInvalidPresentCondition = false
      }
    },
    validatePreviousHistory() {
      if (isNull(this.editForm.previousHistory)) {
        this.isInputInvalidPreviousHistory = true
      } else {
        this.isInputInvalidPreviousHistory = false
      }
    },
    
    //验证诊断
    validateDiagnosis() {
      if (_.isEmpty(this.editForm.diagnosisList)) {
        this.isInputInvalidDia = true
      } else {
        this.isInputInvalidDia = false
      }
    },
    //验证是否输入主诉和诊断
    validateInput() {
      if (isNull(this.editForm.patientTell)) {
        this.isInputInvalid = true
      } else {
        this.isInputInvalid = false
      }
      if (isNull(this.editForm.presentCondition)) {
        this.isInputInvalidPresentCondition = true
      } else {
        this.isInputInvalidPresentCondition = false
      }
      if (isNull(this.editForm.previousHistory)) {
        this.isInputInvalidPreviousHistory = true
      } else {
        this.isInputInvalidPreviousHistory = false
      }
      if (isNull(this.editForm.facePalpation)) {
        this.isInputInvalidFacePalpation = true
      } else {
        this.isInputInvalidFacePalpation = false
      }


      if (_.isEmpty(this.editForm.diagnosisList)) {
        this.isInputInvalidDia = true
      } else {
        this.isInputInvalidDia = false
      }
    },
    /**
   * 新增患者成功
   */
    addPatientComfirm(patientInfo) {
      this.patientForm = Object.assign({}, this.patientForm, patientInfo)
      this.$computeAge(Common.timeFormat(patientInfo.birthday), this.patientForm);
      // this.patientForm.doctorVisit = "0"
      this.getDoctorVisit()
      this.patientList = []
      //保存选择患者信息
      this.savePatient()
      this.visiblePatientObj.addPatientDialog = false;
    },
    /**
      * 关闭新增患者弹框
     */
    close() {
      this.visiblePatientObj.addPatientDialog = false;
    },
    /**
     * 新增患者按钮
     */
    addPatientDia() {
      this.visiblePatientObj.addPatientDialog = true;
    },
    //删除所有信息
    deleteAllDia() {
      Outpatient.deleteAllDia({ orderId: this.orderId }).then(res => {
        this.$refs['outpatientLeft'].getOutlineList(1)
        this.visiblePatientObj.deleteAllDiagnosisDialog = false;
        this.clearInfo()
      })
    },
    deleteAllDiagnosisDialog() {
      this.visiblePatientObj.deleteAllDiagnosisDialog = true;
    },
    dialogVisibleClose(name) {
      this.visiblePatientObj.deleteAllDiagnosisDialog = false;
    },
    //触底获取更多历史病历
    getMoreHisList() {
      if (this.hasMoreHistoryList && this.historyPageNum <= this.historyTotalPage) {
        this.historyPageNum += 1
        this.getHistoryList(1)
      }
    },

    //切换患者清除内容信息
    clearInfo() {
      this.editForm = {
        // diagnosIds: [],
        dialectical: '',
        patientTell: null,
        previousHistory: null,
        imgs: [],
        doctorAdvice: '',//选择的医嘱
        price: null,
        registerPrice: null,
        // type: '',
        diagnosisList: [],
        presentCondition: null,//现病史
        facePalpation: null,//望闻切诊
        familyHistory: null,//家族史
        allergyHistory: null,//过敏史
        physicalExamination: null,//体格检查
        menstrualHistory:'',//月经史
        accessoryExamination:'',//辅助检查
        preNotes:''
      };
      this.registerResp = {}//清空预计就诊时间
      this.diagnosIds = [];
      this.diagnosisList = [];
      this.fileList = [];
      this.attachmentShow = false;
      this.patientForm = {
        patientName: "",
        sex: '0',
        year: "",
        month: "",
        phone: "",
        doctorVisit: "0"
      };//患者对象
      this.orderId = null//清除门诊id
      this.isRegister = {//是否是挂号患者
        price: null,//快捷开方价格
        registeredPrice: null,//正常挂号
      };
      this.drugItem = [];
      this.physioItem = [];
      this.chineseMedicineItem = [];
      this.otherItem = {};
      this.isInputInvalid = false;//主诉和诊断是否填写
      this.isInputInvalidDia = false;
      this.isInputInvalidPresentCondition = false;
      this.isInputInvalidPreviousHistory = false;
      this.isInputInvalidFacePalpation = false;
      this.historyList = [];
      this.historyTotal = null;
      this.isDisabled = false;
      this.chooseAdviceList = [];
      this.adviceSelectList = [];
      this.adviceShow = false;
      this.adviceOption.forEach((val, ind) => {
        this.adviceOption[ind].isSelect = false;
      })
      this.$message.closeAll();
      this.preExamineFlag = null;
      this.recipesList = [];
      this.actList = [];
      this.isEdit = false;
      this.diagnosObj={
        diagnosName: '',//诊断 input展示值
        diagnosVisible: false,//诊断，选择列表展示
        activeIndex: 0,
        operateIndex: -1,
        isFocus: false
      },
      this.needUpdateDia=false
      this.menstrualHistoryHtml=''
      this.menstrualHistory=[]
      this.chargePotential = null
      this.$refs.menstruationWarp && this.$refs.menstruationWarp[0] && this.$refs.menstruationWarp[0].initData();
      this.voiceObj={
         recordShow:false,
         diagnosisShow:false,
         diagnosisParams:{}
      },
      this.physioAssetList = []
      this.physioAssetTotal = null
      this.rightTab = this.consultationType === 1 ? 1 : 2
    },
    clearPatient() {
      this.patientForm = {
        patientName: "",
        sex: "",
        year: "",
        month: "",
        phone: "",
        doctorVisit: "0"
      };//患者对象
      // this.savePatient()
    },
    /**
             * 修改患者
             */
    editPatient(type) {
      // 20251010 需求要求谭政可编辑
      if (type === 'edit' && this.doctorId !='509') return
      this.addPatientType = type
      this.patientDialogTitle = type == 'edit' ? '修改患者' : '新增患者'
      this.visiblePatientObj.addPatientDialog = true;
    },

    handleClickOutside(event) {
         // 如果点击的不是目标 DIV 或目标 DIV 的子元素，则隐藏目标 DIV
         let isFocus = document.getElementById('adviceInput') == document.activeElement
        if (!isNull(this.$refs.adviceSelect)) {
          if (!this.$refs.adviceSelect.contains(event.target) && !this.$refs.adviceTextarea.contains(event.target) && !isFocus) {
            this.adviceShow = false;
          } else {
            // this.adviceShow = true
            this.showAdvice()
          }
        }
        if (!isNull(this.$refs.caseDom)) {
          if (!this.$refs.caseDom.contains(event.target) && !this.$refs.caseBtn.contains(event.target)) {
            this.showCase = false;
          }
        }
        //如果不是点击诊断地方，搜索药是不是医保诊断
        let dom=this.$refs['diagnoseDom'];
        if(!isNull(dom)){
          if(!dom.contains(event.target)){
            if(this.needUpdateDia){
              this.searchDiaNames()
            }
          }
        }

        if(this.$refs.menstruationWarp) {
            //点击月经婚育史以外的地方关闭弹框
          let menstruationWarp = this.$refs.menstruationWarp[0].$refs.menstruation
          let menstruationInput = this.$refs.menstruationInput[0]
          if(!isNull(menstruationWarp)){
            if(!menstruationInput.contains(event.target) && !menstruationWarp.contains(event.target)){
              this.menstruationShow=false;
            }
          }
        }
        if(this.$refs.presentConditionWarp) {
            //点击现病史以外的地方关闭弹框
          let presentConditionWarp = this.$refs.presentConditionWarp[0].$refs.menstruation
          let presentConditionInput = this.$refs.presentConditionInput[0].$el
          if(!isNull(presentConditionWarp)){
            if(!presentConditionInput.contains(event.target) && !presentConditionWarp.contains(event.target)){
              this.presentConditionShow=false;
            }
          }
        }
        if(this.$refs.presentConditionWarp) {
            //点击既往病史以外的地方关闭弹框
          let previousHistoryWarp = this.$refs.previousHistoryWarp[0].$refs.menstruation
          let previousHistoryInput = this.$refs.previousHistoryInput[0].$el
          if(!isNull(previousHistoryWarp)){
            if(!previousHistoryInput.contains(event.target) && !previousHistoryWarp.contains(event.target)){
              this.previousHistoryShow=false;
            }
          }
        }
        if(this.$refs.allergyHistoryWarp) {
            //点击既往病史以外的地方关闭弹框
          let allergyHistoryWarp = this.$refs.allergyHistoryWarp[0].$refs.menstruation
          let allergyHistoryInput = this.$refs.allergyHistoryInput[0].$el
          if(!isNull(allergyHistoryWarp)){
            if(!allergyHistoryInput.contains(event.target) && !allergyHistoryWarp.contains(event.target)){
              this.allergyHistoryShow=false;
            }
          }
        }
        if(this.$refs.assistantRemarkWarp) {
            //点击既往病史以外的地方关闭弹框
          let assistantRemarkWarp = this.$refs.assistantRemarkWarp.$refs.menstruation
          let assistantRemarkInput = this.$refs.assistantRemarkInput.$el
          if(!isNull(assistantRemarkWarp)){
            if(!assistantRemarkInput.contains(event.target) && !assistantRemarkWarp.contains(event.target)){
              this.assistantRemarkShow=false;
            }
          }
        }
        // 关闭复诊备注选项
        this.repeatVisitInfo.remarkInfo.showRemark = false
    },

    /**
   * 处理诊断数据
   */
    handlediagnosisData() {
      let diagnosis = []
      this.diagnosIds.forEach(item => {
        diagnosis.push(item.name)
      })
      return diagnosis.join(';')
    },
    /**
   * 图片放大
   * @param {*} file 
   */
    handlePictureCardPreview(file,imgIndex) {
      this.imgIndex = Number(imgIndex)
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // this.preImage = this.fileList.map(val => val.url)
      this.$nextTick(() => {
        this.$refs.images.clickHandler()
        // document.getElementById('image').click()
      })
    },
    /**
     * 上传前
     */
    beforeUpload(file) {
      let isImg = (file.type == 'image/jpeg' || file.type == 'image/png' || file.type == 'image/jpg');
      if (!isImg) {
        this.$message.error('只能上传图片格式')
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
        return false;
      }
    },
    /* 图片处理模块 开始 */
    // 图片上传成功
    async handleImgSuccess(data) {
      this.uploading = true
      let arr = []
      arr[0] = { uploadChannel: "postImg", fileId: data, groupName: "group1", isNeedThumbnail: "2" }
      uploadTemporaryFile(arr).then(async uploadRes => {
        this.uploading = false
        if (uploadRes.errorCode == '0000') {
          if (this.type == '4') {
            const res = await req.post('/caseDiagnosis/updateImages', {
              orderId: this.orderId,
              images: [uploadRes.data[0].fullPathUrl]
            })
            if (res.code == 200) {
              this.getCase()
              this.getHandleHistory()
            }
          } else {
            let editForm = _.cloneDeep(this.editForm)
            editForm.imgs.push(uploadRes.data[0].fullPathUrl)
            this.$set(this, 'editForm', editForm)
            this.editCaseDiagnosis()
          }
        } else {
          this.$message.error('上传失败')
        }
      }).catch(err => {
        this.uploading = false;
        this.$message.error('上传失败')
      })

    },
    /**
     * 移除图片
     * @param {*} file 
     * @param {*} fileList 
     */
    handleRemove(file) {
      // this.fileList = fileList;
      let editForm = _.cloneDeep(this.editForm)
      editForm.imgs = editForm.imgs.filter(v => v != file)
      this.$set(this, 'editForm', editForm)
      // if (fileList.length != 0) fileList.forEach(item => { this.editForm.imgs.push(item) });
      // if (this.type != 3) {
      this.editCaseDiagnosis()
      // }
    },
    // 图片超出数量
    excessNum() {
      this.$message('已超出数量最大上传数量9，请删除部分再试！');
    },



    /**
     * 设置医嘱模版
     */
    setAdviceModal() {
      this.dialogTitle = '设置医嘱模版'
      this.dialogWidth = '690px'
      this.componentName = 'adviceDialog'
      this.dialogShow = true
    },
    //医嘱聚焦
    showAdvice() {
      this.adviceShow = true
      
      this.$nextTick(() => {
        const adviceSection = this.$refs.adviceSection
        adviceSection.scrollIntoView({ behavior: 'smooth' })
      })
    },
    //编辑医嘱
    editAdvice: _.debounce(function (e) {
      this.chooseAdviceList = [];
      this.adviceSelectList = [];
      this.adviceOption.forEach((val, ind) => {
        this.adviceOption[ind].isSelect = false;
      })
      if (e != '') {
        let eSpl = e.split('\n')
        let neweSpl = eSpl.filter(val => val != '')
        //替换所有的序号
        let reg = /\d+\./g
        neweSpl = _.flattenDeep(neweSpl.map(i => (i.substring(0,5).replace(reg,'')+i.substring(5))))
        neweSpl = neweSpl.filter(val => val != '')
        neweSpl = neweSpl.map((k, ind) => (ind + 1) + '.' + k)
        let obj = {
          content: neweSpl.join('\n'),
          delFlag: "0",
          doctorAdviceTemplateId: 'own'
        }
        this.chooseAdviceList = [obj]
        if (neweSpl.length != this.adviceLength) this.handleAdvice()
      }
      this.editCaseDiagnosis()
    }, 500),
    //处理展示的advice
    handleAdvice() {
      // 如果为空或者不是数组返回
      if (_.isEmpty(this.chooseAdviceList) && !_.isArray(this.chooseAdviceList)) return;
      //替换所有的换行
      let contentList = this.chooseAdviceList.map(val => (val.content.split(/\r/g) && val.content.split(/\n/g)));
      // console.log('1111',contentList[0])
      contentList=_.flattenDeep(contentList);
     let  contentListNew = contentList.filter(val => val != '')
      //替换所有的序号
      let reg = /\d+\./g
      contentListNew = _.flattenDeep(contentListNew.map(i => (i.substring(0,5).replace(reg,'')+i.substring(5))))
      // contentList = contentList.filter(val => val != '')
      contentListNew = contentListNew.map((k, ind) => (ind + 1) + '.' + k);
      this.adviceLength = contentListNew.length
      let name = contentListNew.join('\n');
      this.$set(this.editForm, 'doctorAdvice', name)
    },
    /**
     * 选择医嘱
     */
    selectAdvice(id, selectIndex) {
      if (!this.adviceSelectList.includes(id)) {
        this.adviceSelectList.push(id)
        this.adviceOption[selectIndex].isSelect = true
        this.chooseAdviceList = this.chooseAdviceList.concat([this.adviceOption[selectIndex]])
      } else {
        this.adviceOption[selectIndex].isSelect = false
        this.adviceSelectList = this.adviceSelectList.filter(val => val != id)
        this.chooseAdviceList = this.chooseAdviceList.filter(val => val.doctorAdviceTemplateId != id)
      }
      this.handleAdvice()
      this.editCaseDiagnosis()
    },
    //获取操作记录
    getHandleHistory() {
      CommonDTO.caseDiagnosisRecordDTO({ orderId: this.orderId }).then(res => {
        this.loading=false
        if (res.code == 200) {
          this.getHandleHistoryList = res.data
        }
      })
    },
    /**
     * 选择处方模版
     */
    openPrescriptionTemplateDialog() {
      if (isNull(this.doctorInfo.doctorId) || isNull(this.patientForm.patientId)) {
        return this.$message.error('请先填写医生、销售员和患者信息')
      }
      this.dialogWidth = '1020px'
      this.componentName = 'prescriptionTemplateDialog'
      this.dialogTitle = '处方模版'
      this.dialogShow = true
    },
    openComboSelect () {
      this.$refs['comboSelect'].open()
    },
    /**
     * 使用隐秘处方
     */
    userCombo(item) {
      this.comboItem.push(item)
      if (this.type != 3) {
        // this.editOrderStaging()
      }
      this.closeDialog()
    },
    /**
     * 新增理疗处方
     */
    addPhysio() {
      if (isNull(this.doctorInfo.doctorId) || isNull(this.patientForm.patientId)) {
        return this.$message.error('请先填写医生、销售员和患者信息')
      }
      let obj = {
        orderId: this.orderId,
        recipeSourceType: '0',
        projectType: '0',
        recipeType: '3',
        remark: '',
        totalPrice: 0,
        items: [
          {
            spuId: '',
            itemId: '',
            itemName: '',
            itemNum: null,
          }
        ]
      }
      this.physioItem.push(obj)
      this.$nextTick(() => {
        // this.$forceUpdate()
        let physioCom = this.$refs.physioCom;
        physioCom && physioCom.handlePhy(obj)
      })
      this.scrollTop()
    },
    /**
    * 新增隐秘处方
    */
    addCombo() {
      if (isNull(this.doctorInfo.doctorId) || isNull(this.patientForm.patientId)) {
        return this.$message.error('请先填写医生、销售员和患者信息')
      }
      this.dialogWidth = '870px'
      this.componentName = 'comboDialog'
      this.dialogTitle = '隐秘处方'
      this.dialogShow = true
    },
    /**
     * 添加中药处方
     */
    addDrug() {
      if (isNull(this.doctorInfo.doctorId) || isNull(this.patientForm.patientId)) {
        return this.$message.error('请先填写医生、销售员和患者信息')
      }
      this.$nextTick(()=>{
        // this.$forceUpdate()
        let drugDom = this.$refs.drugCom;
        drugDom && drugDom.addDrugItem()
      })
      this.scrollTop()
    },
    /**
   * 使用理疗模板
   */
    async useRecipePhysioDemo(obj) {
      let physioDetail = obj
      let physioItem = physioDetail && physioDetail.recipeTemplateDrugs || [];
      let spu = [];
      physioItem && physioItem.forEach(v=>{ 
        if(v.spuId > 0){
          spu.push({spuId:v.spuId })
        }
      })
      let { data } = await Outpatient.getInventory({
        doctorId:this.doctorInfo.doctorId,
        spu,
        deptId: this.consultationType === 2 ? process.env.VUE_APP_CHAT_DEPT_ID : this.$session.get('deptId'),
        recipeType: '3'
      })
      data && data.forEach(v1=>{
        physioItem.forEach(v2=>{
          if (isNull(v2.spuId) || v2.spuId < 0 || v2.spuId == 0) {
            v2.onSale = 0
          }
          if(v1.spuId === v2.spuId){
            if(isNull(v2.physioExtendJson)){
              v2.physioExtendJson = {
                perUnit: v1.perUnit,
                perUnitCount: v1.perUnitCount,
                executionMode: v1.executionMode,
                soldNum:1,
                onlyNum:v1.executionMode == 20 ? 3 : null,
                physioIntervalEnum:null,
                acupointinfoList:[]
              }
            }
            v2.enableStatus = v1.enableStatus
            v2.price = v1.price
            v2.itemName = v1.spuCommonName
            v2.itemUnit = v1.unit
            v2.itemId = v1.spuId
            if(v1.executionMode == 10){
              v2.physioExtendJson.onlyNum = ''
            }else{
              v2.physioExtendJson.onlyNum = isNull(v2.onlyNum) ? 3 : v2.onlyNum
            }
            v2.physioExtendJson.soldNum = v2.soldNum
            v2.itemNum = v1.executionMode == 20 ? this.$bigNumber(isNull(v2.onlyNum) ? 3 : v2.onlyNum, '*', v2.soldNum) : v2.soldNum
            v2.physioExtendJson.perUnit = v1.perUnit
            v2.physioExtendJson.perUnitCount = v1.perUnitCount
            v2.physioExtendJson.executionMode = v1.executionMode
            v2.physioExtendJson.acupointinfoList = v2.acupointinfoList
            v2.physioExtendJson.physioIntervalEnum = v2.physioIntervalEnum
            v2.effectDrugPriceConfig = v1.effectDrugPriceConfig
            if(v1.effectDrugPriceConfig && v1.effectDrugPriceConfig.configType == 1){
              v2.price = v1.effectDrugPriceConfig.fixedPrice
            }else if(v1.effectDrugPriceConfig && v1.effectDrugPriceConfig.configType == 2){
              let config = this.findPriceRange(v2.itemNum,v1.effectDrugPriceConfig.ladderPriceConfigs)
              v2.price = isNull(config) ? v2.price : config.ladderPrice
            }
          }
        })
      })
      let temObj = {
        orderId: this.orderId,
        projectType: '0',
        isYlcp: obj.isYlcp,
        recipeType: '3',
        totalPrice: 0,
        items: physioItem,
      }
      Outpatient.editPrescription(temObj).then(res => {
        if (!temObj.orderCaseProjectRecipeId) {
          temObj.orderCaseProjectRecipeId = res.data;
          this.addSearch(temObj.items, 'physio')
          this.physioItem.push(temObj);
          this.dialogShow = false;
          this.$message.success("使用理疗处方模板成功！");
        }
      })
    },
    /**
   * 更新drugItem的值
   */
    updateDrugItem(drugItem) {
      this.$set(this, 'drugItem', drugItem)
      this.$forceUpdate()
    },
    /**
      * 更新otherItem的值
    */
    updateOtherItem(otherItem) {
      this.$set(this, 'otherItem', otherItem)
      this.$forceUpdate()
    },
    /**
    * 更新chineseMedicineItem的值
    */
    updataChineseMedicineItem(chineseMedicineItem) {
      this.$set(this, 'chineseMedicineItem', chineseMedicineItem)
      this.$forceUpdate()
    },
    /**
   *更新comboItem数据
   */
    // updataComboItem(comboItem) {
    //   this.$set(this, 'comboItem', comboItem)
    //   if (this.type != 3) {
    //     this.editOrderStaging()
    //   }
    //   this.$forceUpdate()
    // },
    /**
   *更新physioItem数据
   */
    updataPhysioItem(physioItem) {
      this.$set(this, 'physioItem', physioItem)
      this.$forceUpdate()
    },
    /**
   * 使用处方模版
   */
    recipeInfoBack(val) {
      if (val.type == '0') this.useRecipeDrugDemo(val); // 中药模板
      else this.useRecipePhysioDemo(val); // 理疗模板
    },
    /**
     * 使用中药模板
     */
    async useRecipeDrugDemo(obj) {
      let spu = [];
      obj.recipeTemplateDrugs.forEach(item => { 
        if(item.spuId > 0){
          spu.push({spuId:item.spuId,type:item.firstCategory}) 
        }
      });
      let recipeDrugItem = [];
      // 通过kinId查询商品库存以及禁用标识
      let { data } = await Outpatient.getInventory({
        spu,
        deptId: this.consultationType === 2 ? process.env.VUE_APP_CHAT_DEPT_ID : this.$session.get('deptId'),
        recipeType: '1'
      })
      obj.recipeTemplateDrugs.forEach(kid => {
        if (isNull(kid.spuId) || kid.spuId < 0 || kid.spuId == 0) {
          recipeDrugItem.push({ ...kid, onSale: 0, id: kid.spuId })
        }
        data.forEach(item => {
          if (item.spuId == kid.spuId) {
            recipeDrugItem.push({ ...kid, ...item,isOwned:'0'})
          }
        })
      })
      // 计算处方价格和重量
      let totalPrice = 0,
        weight = 0;
      recipeDrugItem.forEach(item => {
        item.oldDrugName = item.spuCommonName
        totalPrice = this.$bigNumber(totalPrice, '+', this.$bigNumber(item.price, '*', item.number));
        weight = this.$bigNumber(weight, '+', item.number);
      });
      recipeDrugItem = Common.nameChange(recipeDrugItem, 1)
      let temObj = {
        orderId: this.orderId,
        sourceRecipeId: obj.recipeTemplateId,
        projectType: '0',//0处方项目
        recipeType: 1,//中药处方
        recipeSourceType: isNull(obj.recipeSourceType) ? '0' : obj.recipeSourceType,
        doseNum: obj.doseNum || 1,
        doseType: obj.doseType,//颗粒，饮片，全部
        recipeMethod: obj.recipeMethod,//煎法
        recipeMoment: obj.recipeMoment,//服用时机
        frequency: obj.frequency,
        takingDosage: obj.takingDosage,
        takingDays: obj.takingDays,
        applicationTime: obj.applicationTime,
        wrapTime: obj.wrapTime,
        isYlcp: obj.isYlcp,
        bakingPowderDosage: obj.bakingPowderDosage,
        creamDosage: obj.creamDosage,
        pelletizingDosage: obj.pelletizingDosage,
        doseFrequency: doseOptions.includes(obj.doseFrequency) ? obj.doseFrequency : '',
        mixingBagNum: obj.mixingBagNum,//冲服
        remark: obj.remark,
        weight: 0,//药品总重
        processFlag: '0',//是否加工
        process: {//加工信息
          processName: '',
          processPrice: '',
          bagNum: '',
          remark: '',
          processingValue: "[]",
        },
        items: recipeDrugItem
      }
      Outpatient.editPrescription(temObj).then(res => {
        if (!temObj.orderCaseProjectRecipeId) {
          temObj.orderCaseProjectRecipeId = res.data;
          this.addSearch(temObj.items, 'drug',obj.doseType)
          this.drugItem.push(temObj);
          this.$nextTick(() => {
            let drugDom = this.$refs.drugCom;
            // drugDom && drugDom.addMethod()
            drugDom && drugDom.computeItemTotalPrice(temObj)
          })
        }
      })
      // 中药处方赋值
      this.dialogShow = false;
      this.$message.success('使用模版成功');
    },
    /**
     * 选择诊断
     */
    diagnosChange(e) {
      this.$refs.diagnoseSelect.query = ''
      let arr = []
      e.forEach(item => {
        if (isObject(item)) {
          arr.push({
            diagnoseCode: item.code,
            diagnoseName: item.name,
            ybScope: item.ybScope,
          })
        } else {
          arr.push({
            diagnoseCode: '',
            diagnoseName: item,
            ybScope: 3,
          })
        }
      })
      this.editForm.diagnosisList = arr
      setTimeout(() => {
        this.$refs.diagnoseSelect.blur()
      }, 50)
      this.editCaseDiagnosis()
      this.validateDiagnosis()
    },
    /**
     * 查询诊断
     */
    meetDiagnose: debounce(function (val, e, i) {
      this.diagnosisList = []
      if(isNull(val)){//整个输入框都清空的情况
        this.diagnosObj.diagnosName='';
        this.editForm.diagnosisList=[]
        this.editCaseDiagnosis()
      }
      let content = this.getOperateDiangosisItem()
      // if (!isNull(val)) {
      if (content) {
        meetDiagnose({ search: content, pageNum: 1, pageSize: 30 }).then(res => {
          if (res.code == 200) {
            this.diagnosisList = [...this.diagnosisList, ...res.rows]
            if (!_.isEmpty(this.diagnosisList)) {
              this.diagnosObj.diagnosVisible = true
            }
            this.$forceUpdate()
          }
        })
      }
    }, 300),
    // 获取页面显示的name
    getDiagnosisName(item) {
      let diagnosObj = this.diagnosObj
      let diagnosIds = this.diagnosIds
      let diagnosName =this.changeSign(this.diagnosObj.diagnosName)  || ''
      let arr = diagnosName ? diagnosName.split(';') : []
      if (diagnosObj.operateIndex > -1) {
        arr.splice(diagnosObj.operateIndex, 1, item.name)
      } else {
        arr.push(item.name)
      }
      this.diagnosObj.diagnosName = arr.join(';')
    },
    changeSign(name){
      if(!isNull(name)){
        return name.replace(/；/g,';')
      }else{
        return ''
      }
    },
    //选择诊断
    getDiagnosisItem(item) {
      let diagnosIds = this.editForm.diagnosisList || []
      let index = diagnosIds.findIndex(v => { return v.diagnoseCode == item.code })
       if(index>-1){//已选择过诊断
        this.$message.error('已选择');
        return
       }else{
      let last = this.getDiangosisLast()
      if (last.isBol) {
        this.removeDiangosisLast()
      }
      this.editForm.diagnosisList.push({
        diagnoseCode: item.code,
       diagnoseName: item.name,
       ybScope: item.ybScope
      })
      this.getDiagnosisName(item)
      this.searchDiaNames()
      this.diagnosObj.diagnosVisible = false
      this.diagnosObj.activeIndex = 0
      this.$refs['diagnosePop'].doClose()
      this.$refs['diagnoseInput'] && this.$refs['diagnoseInput'].blur()
       }
    },
    // 获取诊断正在操作的item
    getOperateDiangosisItem() {
      let diagnosName =this.changeSign( this.diagnosObj.diagnosName)
      let dom = this.$refs['diagnoseInput'].$el.firstChild || {}
      let idx = dom.selectionStart
      let valueIdx = 0
      let arr = diagnosName.split(';') || []
      if (idx > -1) {
        let size = 0
        valueIdx = arr.findIndex((v, i) => {
          let start = size + i
          let end = size + i + v.length
          size += v.length
          return idx >= start && idx <= end
        })
      }
      this.diagnosObj.operateIndex = valueIdx
      return arr[valueIdx]
    },
    removeDiangosisLast() {
      let diagnosName = this.changeSign(this.diagnosObj.diagnosName) || ''
      let arr = diagnosName.split(';')
      arr.splice(-1)
      this.diagnosObj.diagnosName = arr.join(';')
    },
    //抛出最后一个选择的诊断
    getDiangosisLast() {
      let diagnosName =this.changeSign(this.diagnosObj.diagnosName ) || ''
      let arr = diagnosName.split(';')
      let isBol = false;
      isBol = arr[arr.length - 1] ? true : false
      return {
        isBol,//最后一个是否存在内容
        last: arr[arr.length - 1],//最后一个内容
      }
    },
    // 诊断获取焦点
    diagnoseFocusFn() {
      let last = this.getDiangosisLast()
      this.diagnosObj.isFocus = true
      if (last.isBol) {
        this.diagnosObj.diagnosName += ';'
      } else {
        // TODO
      }
      this.$nextTick(()=>{
        let dom=this.$refs['diagnoseInput'];
        console.log('dom',dom);
        dom && dom.focus()
      })
    },
    searchDiaNames(){
      let dom=this.$refs['diagnosePop']
      dom && dom.doClose()
      //失去焦点是时候进行医保查询
      let diagnosName = this.diagnosObj.diagnosName || '';
      //将所有的中文，换成英文，
      diagnosName=diagnosName.replace(/；/g,';')
      let arr = diagnosName.split(';');
      let names = arr.filter(v => !isNull(v))
      if (_.isEmpty(names)) return;
      //调查询诊断接口
      CommonDTO.diagnoseListByName({ names }).then(res => {
        if (res.code == 200) {
          let diaArr = res.data;
          let diagnosisList = []
          names.map(v=>{
            diagnosisList.push({
                  diagnoseCode: '',
                  diagnoseName: v,
                })
          })
          if(!_.isEmpty(diaArr)){
            diagnosisList.map((val,ind) => {
              diaArr.map(k => {
                if (val.diagnoseName == k.name) {
                  diagnosisList[ind].diagnoseCode=k.code
                  diagnosisList[ind].ybScope = k.ybScope
                } 
              })
            })
          }
          this.needUpdateDia=false
          if(_.isEmpty(diagnosisList))return
          this.$set(this.editForm,'diagnosisList',diagnosisList);
          this.editCaseDiagnosis()
          this.validateDiagnosis()
        }
      })
    },
    // 诊断失去焦点
    diagnoseBlurFn() {
      this.diagnosObj.isFocus = false;
      this.needUpdateDia=true
    //  this.searchDiaNames()
    },
    scrollDiagnos(name) {
      let height = 0
      let idx = this.diagnosObj.activeIndex || 0
      let _dom = this.$refs['diagnoseOption'] || {}
      if (idx >= 6) {
        height = 36 //每个item的height为36px
      }
      switch (name) {
        case 'up':
          _dom.scrollTop = _dom.scrollTop - height
          break;
        case 'down':
          _dom.scrollTop = _dom.scrollTop + height
          break;
      }
    },
    // 快捷键事件
    operatekeyDownFn(name) {
      let diagnosisList = this.diagnosisList
      let idx = this.diagnosObj.activeIndex || 0
      switch (name) {
        case 'up':
          idx--
          idx = idx < 0 ? 0 : idx
          this.diagnosObj.activeIndex = idx
          this.scrollDiagnos(name)
          break;
        case 'down':
          idx++
          idx = idx > diagnosisList.length - 1 ? diagnosisList.length - 1 : idx
          this.diagnosObj.activeIndex = idx
          this.scrollDiagnos(name)
          break;
        case 'enter':
          let dom = this.$refs['diagnoseOption']
          if(!dom)return
          this.getDiagnosisItem(diagnosisList[idx])
          break;
      }
    },
    /**
     * 弹框关闭按钮
     */
    closeDialog() {
      if (this.componentName == 'uploadDialog') {
        if (this.$refs.component.phoneUpload) {
          this.dialogTitle = ''
          this.componentName = ''
          this.dialogShow = false
          this.getCase()
        } else {
          this.dialogWidth = '450px'
          this.dialogTitle = ''
          this.componentName = ''
          this.dialogShow = false
        }
      } else {
        this.dialogWidth = '450px'
        this.dialogTitle = ''
        this.componentName = ''
        this.dialogShow = false
        this.getAdviceList()
      }
    },
    /**
     * 上传图片
     */
    handleUpload() {
      if (isNull(this.patientForm.patientName) || isNull(this.patientForm.sex) || isNull(this.patientForm.year) || isNull(this.patientForm.month)) {
        return this.$message.error('请填写患者信息')
      }
      this.componentName = 'uploadDialog'
      this.dialogTitle = '上传方式'
      this.dialogShow = true
    },
    /**
     * 本地上传
     */
    localUpload() {
      this.attachmentShow = true
      this.dialogShow = false
      this.$nextTick(() => {
        // console.log('this.$refs.uploadImage', this.$refs.uploadImage.$el.querySelector('input'));

        this.$refs.uploadImage.$el.querySelector('input').click()
      })
    },
    /**
     * 查询医生信息
     * @param {*} id 医生id
     */
    async getDoctorDetail(id) {
      if (isNull(id)) return
      let { data, code } = await doctorInfo(id);
      if (code == 200) {

        this.doctorList = [];
        this.doctorList.push({
          ...data
        })
        let deptArr = []
        if (!isNull(data.sysPosts)) {
          data.sysPosts.forEach(item => { deptArr.push(item.postName) })
        }
        data.sysPostsStr = deptArr.join('/')
        this.doctorInfo = data
        this.doctorInfo.salesPerson = data.doctorName

      }
    },
    /**
     * 费用预览
     */
    handleCostPreview() {
      this.componentName = 'costPreview'
      this.dialogTitle = '费用预览'
      this.dialogWidth = '608px'
      this.dialogShow = true
    },
    //如果是编辑，先保存一次处方，在保存诊断
    saveCurPrescription(obj) {
      return new Promise((resolve, reject) => {
        Outpatient.editPrescription(obj).then(res => {
          if (res.code == 200) resolve(res.data)
        })
      })
    },
    //保存之前先验证是否所有都填写完成
    async beforeSave(check, inventory = false) {
      let flag = false
      this.drugList = []
      let drugList = []
      let spu = [];
      let inventoryFlag = false
      if (isNull(this.doctorId) || isNull(this.doctorInfo.doctorId)) {
        this.$message("医生不能为空，请选择后再试！");
        return false;
      }
      this.validateInput()
      if(this.isDoctor){
        if (this.isInputInvalid) {
          this.$message.error('请输入主诉!')
          return false;
        }
        if (this.isInputInvalidPresentCondition) {
          this.$message.error('请输入现病史!')
          return false;
        }
        if (this.isInputInvalidPreviousHistory) {
          this.$message.error('请输入既往病史!')
          return false;
        }
        if(this.isInputInvalidFacePalpation){
          this.$message.error('请输入望闻问切!')
          return false;
        }
        if(this.isInputInvalidDiagnosis){
          this.$message.error('请输入诊断!')
          return false;
        }
      }
      // 如果不需要检验库存或理疗禁用项目，则直接返回校验成功
      if (check == 0) return true
      if (Utils.gt(this.drugItem.length, 0)) {
        let newDrugItem = deepClone(this.drugItem)
        newDrugItem.forEach(item => {
          this.deleteSearch(item.items, 'drug')
          if (!item.doseNum) {
            flag = true
            this.$message.error('处方剂量不能为空！')
          }
          let index = item.items.findIndex(obj => isNull(obj.itemNum) || Utils.eq(obj.itemNum, 0))
          if (Utils.gt(index, -1)) {
            flag = true
            this.$message.error('药品数量不能为0！')
          }
          if(item.recipeMethod==="煎服" && isNull(item.takingDosage)){
            flag = true
            this.$message.error('处方服用量不能为空！')
          }
          item.items.forEach(obj => {
            if(obj.isOwned && obj.isOwned=='0'){
              spu.push({spuId:obj.spuId,type:obj.doseType})
            }
            drugList.push({ ...obj, itemNum: this.$bigNumber(obj.itemNum, '*', item.doseNum) })
          })
        })
      }
      if (Utils.gt(this.physioItem.length, 0)) {
        let newPhysioItem = deepClone(this.physioItem)
        newPhysioItem.forEach(item => {
          this.deleteSearch(item.items, 'physio')
          let index = item.items.findIndex(obj => isNull(obj.itemId))
          item.items.forEach(obj => {
            if(obj.physioExtendJson && obj.physioExtendJson.perUnitCount ){
              if(this.computedPerUnitCount(obj.physioExtendJson) < (obj.physioExtendJson.executionMode == 10 ? obj.physioExtendJson.perUnitCount : obj.physioExtendJson.perUnitCount * obj.physioExtendJson.onlyNum)){
                flag = true
                this.$message.error('请补全理疗项目的穴位/部位后完诊')
              }
            }
            if(isNull(obj.executeDesc)){
              flag = true
              this.$message.error('请选择理疗项目频次！')
            }
            if([0, '0', '', null, undefined].includes(obj.itemNum)){
              flag = true
              this.$message.error('理疗项目数量不能为0或空！')
            }
            spu.push({spuId:obj.spuId})
            // recipeType=3为理疗项目的标识，用于保存时弹窗提示禁用的理疗项目展示
            drugList.push({ ...obj, recipeType: item.recipeType, itemNum: this.$bigNumber(obj.itemNum, '*', 1) })
          })
        })
      }
      if (Utils.gt(this.chineseMedicineItem.length, 0)) {
        let newChineseMedicineItem = deepClone(this.chineseMedicineItem)
        newChineseMedicineItem.forEach(item => {
          this.deleteSearch(item.items, 'chineseMedicine')
          let index = item.items.findIndex(obj => isNull(obj.itemId))
          item.items.forEach(obj => {
            spu.push({spuId:obj.spuId})
            drugList.push({ ...obj, itemNum: this.$bigNumber(obj.itemNum, '*', 1) })
            if(isNull(obj.useFrequency)){
              flag = true
              this.$message.error('请选择用药频次！')
            }
            if(isNull(obj.singleDose)){
              flag = true
              this.$message.error('请输入单次剂量！')
            }
            if(isNull(obj.singleDoseUnit)){
              flag = true
              this.$message.error('请选择单位！')
            }
            if(isNull(obj.takingTime)){
              flag = true
              this.$message.error('请选择服用时间！')
            }
            if(isNull(obj.intervalRequirement)){
              flag = true
              this.$message.error('请选择间隔时间！')
            }
            if([0, '0', '', null, undefined].includes(obj.itemNum)){
              flag = true
              this.$message.error('中成药数量不能为0或空！')
            }
          })
        })
      }
      if (Utils.gt(this.actList.length, 0)) {
        let newActList = deepClone(this.actList)
        newActList.forEach(item => {
          let index = item.items.findIndex(obj => isNull(obj.itemId))
          item.items.forEach(obj => {
            if (obj.drugType === 1) {
              if(obj.physioExtendJson && obj.physioExtendJson.perUnitCount ){
                if(this.computedPerUnitCount(obj.physioExtendJson) < (obj.physioExtendJson.executionMode == 10 ? obj.physioExtendJson.perUnitCount : obj.physioExtendJson.perUnitCount * obj.physioExtendJson.onlyNum)){
                  flag = true
                  this.$message.error('请补全套餐中理疗项目的穴位/部位后完诊')
                }
              }
              if(isNull(obj.executeDesc)){
                flag = true
                this.$message.error('请选择套餐中理疗项目频次！')
              }
              if([0, '0', '', null, undefined].includes(obj.itemNum)){
                flag = true
                this.$message.error('套餐中理疗项目数量不能为0或空！')
              }
            }
          })
        })
      }
      if (Utils.gt(this.otherItem.items.length, 0)) {
        let newOtherItem = deepClone(this.otherItem)
        this.deleteSearch(newOtherItem.items, 'other');
        newOtherItem.items.forEach(obj => {
          spu.push({spuId:obj.spuId})
          drugList.push({ ...obj, itemNum: this.$bigNumber(obj.itemNum, '*', 1) })
          if([0, '0', '', null, undefined].includes(obj.itemNum)){
            flag = true
            this.$message.error('非处方项目数量不能为0或空！')
          }
        })
      }
      if (flag) {
        return false
      }
      spu = uniqueArray(spu,'spuId') //去重
      let newDrugList = delSomeObjValue(drugList, 'spuId', 'itemNum')
      if (!inventory) {
        // 通过kinId查询商品库存以及禁用标识
        let { data } = await Outpatient.getInventory({
          doctorId:this.doctorInfo.doctorId,
          spu,
          deptId: this.consultationType === 2 ? process.env.VUE_APP_CHAT_DEPT_ID : this.$session.get('deptId'),
          recipeType: '0'
        })
        newDrugList.forEach(drugObj => {
          if (isNull(drugObj.spuId)) { drugObj.onSale = '0' }
          data.forEach(dataItem => {
            if (dataItem.spuId == drugObj.spuId) {
              drugObj.onSale = dataItem.onSale
              drugObj.inventory = dataItem.inventory
              drugObj.goodsType = dataItem.goodsType
            }
          })
        })
        newDrugList = newDrugList.filter(v=>{ return v.isOwned != '1' })
        inventoryFlag = newDrugList.some(kid => { return kid.onSale == '0' || (kid.goodsType != '8' && Utils.lt(kid.inventory, kid.itemNum))  })
        this.drugList = newDrugList
      }
      if (inventoryFlag && !inventory) {
        this.inventoryTipsDialogShow = true
        return false
      }
      
      if(!this.validatePhysioData()) {
        // 当前门诊单存在被禁用的理疗项目
        this.inventoryTipsDialogShow = true
        console.log(JSON.parse(JSON.stringify(this.drugList)));
        
        return false
      }
      return true
    },

    // 校验订单中的理疗配方中是否存在被禁用的项目
    validatePhysioData() {
     return this.physioItem.every(item => {
       return item.items.every(items => items.enableStatus !== 2)
     })
    },

    //保存整个处方
    saveDoor:debounce(async function(check, inventory = false, checkPres = true){
      if (inventory) this.inventoryTipsDialogShow = false;
      if (checkPres) {
        // 校验库存、禁用理疗、必填项
        let checkRes = await this.beforeSave(check, inventory)
        if (!checkRes) return
      }
      let orderInfo = {
        orderId: this.orderId,
        ...this.patientForm,
        ...this.doctorInfo,
        price: this.isRegister.price || this.isRegister.registeredPrice,
        deptId: this.deptId
      };
      //处理需要传入对象
      let editForm = _.cloneDeep(this.editForm);
      let caseDiagnosis = {
        orderId: this.orderId,
        ...editForm,
        images: _.toString(editForm.imgs)
      };
      //处理处方内为空的项
      let drugItem = _.cloneDeep(this.drugItem);
      if (!_.isEmpty(drugItem)) {
        drugItem.map((drug, i) => {
          drug.recipeSourceType = isNull(drug.recipeSourceType) ? '0' : drug.recipeSourceType
          drugItem[i].items = drug.items.filter(v => v.itemName && v.itemId)
          if (drug.processFlag == '1' && isArray(drug.process.processingValue)) {
            drug.process.processingValue = JSON.stringify(drug.process.processingValue)
          };
        })
      }
      let physioItem = _.cloneDeep(this.physioItem);
      if (!_.isEmpty(physioItem)) {
        physioItem.map((phy, i) => {
          phy.recipeSourceType = isNull(phy.recipeSourceType) ? '0' : phy.recipeSourceType
          physioItem[i].items = phy.items.filter(v => v.itemName && v.itemId)
        })
      }
       let chineseMedicineItem = _.cloneDeep(this.chineseMedicineItem);
      if (!_.isEmpty(chineseMedicineItem)) {
        chineseMedicineItem.map((cm, i) => {
          cm.recipeSourceType = isNull(cm.recipeSourceType) ? '0' : cm.recipeSourceType
          chineseMedicineItem[i].items = cm.items.filter(v => v.itemName && v.itemId)
        })
      }
      let projectRecipes = [
        ...drugItem,
        ...physioItem,
        ...chineseMedicineItem,
      ];
      let otherItem = _.cloneDeep(this.otherItem);
      if (isArray(otherItem.items)) {
        otherItem.recipeSourceType = isNull(otherItem.recipeSourceType) ? '0' : otherItem.recipeSourceType
        otherItem.items = otherItem.items.filter(v => v.itemName && v.itemId)
        // if (!_.isEmpty(otherItem.items)) {
          projectRecipes.push(otherItem)
        // }
      }
      let obj = {
        orderInfo: {
          ...orderInfo,
          revisitFlag: this.repeatVisitInfo.revisitFlag,
          revisitTime: this.repeatVisitInfo.dateVal || '',
          revisitNotes: this.repeatVisitInfo.remarkInfo.remark || ''
        },
        caseDiagnosis,
        projectRecipes,
        actGroups: this.actList
      }
      if (!this.repeatVisitInfo.revisitFlag == '1' && !this.repeatVisitInfo.revisitFlag == '0') {
        return this.$message.error('请选择是否需要复诊')
      }
      if (obj.orderInfo.revisitFlag == '1' && !obj.orderInfo.revisitTime) {
        return this.$message.error('请选择复诊时间')
      }
      // console.log('saveDoor', obj);
      this.loading = true;
      prescriptionDTO.saveDoorDTO(obj).then(res => {
        if (res.code == 200) {
          this.savePrescription(check, true, false)
        }else{
          this.loading=false;
        }
      })
    },500,true ),
    /**
     * 完成接诊
     */
     savePrescription:debounce(async function(check, inventory = false, checkPres = true){
      
      if (inventory) this.inventoryTipsDialogShow = false;
      if (checkPres) {
        // 校验库存、禁用理疗、必填项
        let checkRes = await this.beforeSave(check, inventory)
        if (!checkRes) return
      }
      if (this.repeatVisitInfo.revisitFlag == '1' && !this.repeatVisitInfo.dateVal) {
        return this.$message.error('请选择复诊时间')
      }
      let obj = {
        check: check,
        orderId: this.orderId,
        webChatOrderId: this.consultationType === 2 ? this.webChatOrderInfoId : null
      }
      this.loading = true;
      Outpatient.saveOrder(obj).then(res => {
        this.loading = false;
        if (res.data.isVoucherRevokedClose) {
          this.$message.error('订单已撤销核销，已关闭订单')
        }
        if (_.isEmpty(res.data.responseList)) {
          if (this.isHelper) {
            window.$trackTool.track({ v: '1', b: 'his_000004', t: 'his_0001' }, { updateTime: new Date().Format('yyyy-MM-dd hh:mm:ss'), orderId: this.orderId })
          } else {
            window.$trackTool.track({ v: '1', b: 'his_000006', t: 'his_0001' }, { updateTime: new Date().Format('yyyy-MM-dd hh:mm:ss'), orderId: this.orderId })
          }
          if (!res.data.isVoucherRevokedClose) {
            this.$message.success('保存成功')
          }
          this.isDisabled = true;
          this.judgeDisabled = true;
          this.hasMoreHistoryList=true;
          this.historyPageNum=1
          if (this.consultationType === 1) {
            this.$refs['outpatientLeft'].getOutlineList(2)
          } else {
            this.$refs['outpatientLeft'].getOnlineList(2)
          }
          this.getHistoryList()
          this.getPhysioProperty()
          this.getNewInfo()
          this.getHandleHistory()
          this.getOutPatientAll(this.orderId)
        } else {
          // 获取保存的最新数据后，再匹配中药处方的id
          this.getOutPatientAll(this.orderId).then(() => {
            let effectsDrugs = res.data.responseList;
            this.drugItem.forEach((val, index) => {
              effectsDrugs.forEach(k => {
                if (val.orderCaseProjectRecipeId == k.orderCaseProjectRecipeId) {
                  k.sortNum = index + 1
                  k.name = '中药处方' + (index + 1)
                }
              })
  
            })
            this.effectsDrugs = effectsDrugs.sort((a, b) => a.sortNum - b.sortNum)
            // 医生签名
            this.componentName = 'effects'
            this.dialogTitle = '相反/相畏药材签名确认'
            this.dialogShow = true;
            this.dialogWidth = '500px'
          })
        }
      }).catch(err => {
        this.loading = false;
        if(err && err.code == 900001 ){
          this.$refs.physioCom.getPhysioList()
        }
      })
     },500,true),
    //完成接诊后更新门诊信息
    getNewInfo() {
      Patient.getPatientInfo({ orderId: this.orderId }).then(res => {
        let info = res.data
        this.orderPayFlag = info.order.orderPayFlag
        this.orderStatus = info.order.orderSourceType;//订单来源
        this.type = info.order.status;//订单状态
        this.isGroupOrder = info.order.isGroupOrder || false;
        this.preExamineFlag = info.order.preExamineFlag;//是否预诊
      })
    },

    /**
     * 选择患者
    */
    async selectPatient(val) {
      this.historyPageNum=1;
      if (Utils.gt(this.patientList.length, 0)) {
        let patient = this.patientList.find(item => {
          return item.patientId == val;
        });
        this.patientForm = Object.assign({}, this.patientForm, patient)
        // this.patientForm.doctorVisit = "1"
        this.getDoctorVisit()
        this.patientList = []
        await this.getRevisitRegisterPrice()
        //保存选择患者信息
        this.savePatient()
        await this.getDoctorPatientSummary()
      }
    },
    /**
     * 获取病历列表
     */
    getHistoryList(num) {
      if (!this.patientForm.patientId) return;
      this.loading = true
      let params = {
        patientName : this.patientForm.patientName,
        patientPhone : this.patientForm.phone,
        pageNum: this.historyPageNum, pageSize: 20, excludeDeptId: '1',
        doctorId: this.doctorId
      }
      historyList(params).then(res => {
        let { code, rows, total } = res
        if (code == 200) {
          rows.forEach(item => {
            item.date = item.createTime && item.createTime.slice(2, 10)
            if (item.images != '' && item.images != null) {
              item.images = item.images.split(',')
            }
            if (!isNull(item.doctorAdvice)) {
              let arr = item.doctorAdvice.split('\n')
              item.doctorAdviceArr = arr
            }
            if(!isNull(item.menstrualHistory)){
              item.menstrualHistory = this.handleMenstrualHistoryHtml(JSON.parse(item.menstrualHistory))
            }
          });
          this.historyTotal = total;
          if (num) {
            this.historyList = this.historyList.concat(rows)
          } else {
            this.historyList = rows;

          }
          this.historyTotalPage = Math.ceil(total / 20)
          if (rows.length < 20) {
            this.hasMoreHistoryList = false
          }
          this.loading = false
        } else {
          this.loading = false
        }
      })
    },
    /**
    * 计算生日
    */
    computeBirthday() {
      this.patientForm.birthday = this.$computeBirthday(this.patientForm.year, this.patientForm.month);
    },
    // 获取所有医生列表
    getDoctorList: debounce(async function (val) {
      if (isNull(val)) return;
      let { code, rows } = await doctorList({ doctorName: val, pageNum: 1, pageSize: 30 })
      if (code == 200) {
        this.doctorList = rows
      }
    }, 500),
    /**
     * 选择医生
    */
    async selectDoctor(val) {
      this.doctorId = val
      this.doctorInfo = this.doctorList.find(item => {
        return item.doctorId == val
      })
      this.doctorInfo.salesPerson = this.doctorInfo.doctorName
      if (this.type != 3 && this.orderStatus != 0) {
        let { code, data } = await getPreRegisPrice({ doctorId: this.doctorId })
        if (code == 200) {
          this.isRegister.price = data
          // this.editOrderStaging()
        }
      }
    },
    /**
     * 输入挂号费
     */
    formatNum: _.debounce(function (e) {
      let temp = e.toString();
      temp = temp.replace(/。/g, ".");
      temp = temp.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
      temp = temp.replace(/^\./g, ""); //验证第一个字符是数字
      temp = temp.replace(/\.{2,}/g, ""); //只保留第一个, 清除多余的
      temp = temp.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      temp = temp.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
      // if (!temp) this.isRegister.price = '0'
    }, 500),
    // 挂号费聚焦
    priceFocus(info){
      let originalPrice = ''
      if (['1', '2'].includes(this.orderStatus)) {
        originalPrice = info.price
      } else {
        originalPrice = info.registeredPrice
      }
      info['originalPrice'] = originalPrice
    },
    // 挂号费失焦
    priceBlur(info){
      if (['1', '2'].includes(this.orderStatus)) {
        if ([null, undefined, ''].includes(info.price)) {
          info.price = 0
        }
      } else {
        if ([null, undefined, ''].includes(info.registeredPrice)) {
          info.registeredPrice = 0
        }
      }
      this.savePatient(1)
    },
    /**
     * 获取医嘱列表
     */
    getAdviceList() {
      adviceList({ deptId: this.$session.get('deptId'), doctorId: this.doctorId }).then(res => {
        let { code, rows } = res
        if (code == 200) {
          rows.forEach(item => {
            item.isSelect = false //是否选中
          })
          this.adviceOption = rows
        }
      })
    },
    /**
     * 添加空白搜索框
     * list 列表
     * type drug中药 physio 理疗 chinsesMedicine 中成药
     */
    addSearch(list, type,doseType='0') {
      if (type == 'drug') {
        list.push({
          itemName: '',
          itemNum: '',
          itemUnit: 'g',
          deleteShow: false,//是否显示删除icon
          handling: '',
          doseType: doseType=='2'?'0':doseType
        })
      } else if (type == 'physio' || type=='chinsesMedicine') {
        list.push({
          itemId: '',
          itemName: ''
        })
      } else if (type == 'other') {
        list.push({
          itemId: '',
          itemName: ''
        })
      }
    },
    /**
     * 删除多余空白数据
     * list 列表
     * type drug中药 physio 理疗
     */
    deleteSearch(list, type) {
      list.forEach((item, index) => {
        if (isNull(item.itemName)) {
          list.splice(index, 1)
        }
      })
    },
    // 根据姓名或电话号码获取患者列表
    async getPatientInfo(name, phone) {
      if (name != "" || phone != "") {
        this.patientFormLoading = true;
        let { code, data } = await patientInfom({ name: name, phone: phone });
        this.patientList = [];
        if (code == 200) {
          this.patientFormLoading = false;
          data.forEach(item => {
            this.$computeAge(item.birthday, item);
          });
          this.patientList = data;
        }
      } else {
        this.patientList = [];
      }
    },
    // 根据姓名获取患者列表
    getPatientInfoByPhone: _.debounce(async function (phone) {
      let { code, data } = await patientInfom({ phone })
      this.patientList = [];
      if (code == 200) {
        data.forEach(item => { this.$computeAge(item.birthday, item) })
        this.patientList = data;
      }
    }, 500, true),
    /**
     * 修改
     */
    handleEdit() {
      this.isDisabled = false
      if(!this.isHelper && this.type!=2){
        this.isEdit = true;
        this.$nextTick(() => {
              let drugDom = this.$refs.drugCom;
              drugDom && drugDom.addMethod()
  
            })
      }
    },

    /**
     * 医生签名
     */
    doctorSign() {
      this.dialogShow = false;
      this.componentName = ''
      this.savePrescription('0')
    },
    /**
     * 完成上传
     */
    uploadCompany() {
      this.dialogTitle = ''
      this.componentName = ''
      this.dialogShow = false
      this.getCase()
      if (this.type == '4') {
        this.getHandleHistory()
      }
    },
    //打印单个处方
    handlePrint(item) {
      let { orderCaseProjectRecipeId, recipeType } = item;
      console.log('orderCaseProjectRecipeId', orderCaseProjectRecipeId);
      this.printOrderId = orderCaseProjectRecipeId
      this.isBatch = false
      this.printType = '2'
        switch(recipeType){
        case '1':  //中药
          this.printorderType = '1'
          break;
        case '3':  //理疗
          this.printorderType = '2'
          break;
        case '4':  //中成药
          this.printorderType = '1'
          break;
      }
      this.$nextTick(() => {
        this.$refs.printDia.useDefaultPrint()
      })
    },
    //批量打印处方和病例
    orderHandleCommand(val) {
      this.printType = val
      switch (val) {
        case '2':
          const actHasOrderList = this.actList.filter(v => { return ![null, undefined, ''].includes(v.orderCaseProjectRecipeId) })
          if (_.isEmpty(this.drugItem) && _.isEmpty(this.physioItem) && _.isEmpty(this.chineseMedicineItem) && _.isEmpty(actHasOrderList)) {
            this.$message.error('暂无处方')
            return
          }
          this.isBatch = true
          let printListObj = []
          this.drugItem.forEach(item => {
            printListObj.push({
              printType: val,
              id: item.orderCaseProjectRecipeId,
              orderType: '1'
            })
          })
          this.physioItem.forEach(item => {
            printListObj.push({
              printType: val,
              id: item.orderCaseProjectRecipeId,
              orderType: '2'
            })
          })
          this.chineseMedicineItem.forEach(item => {
            printListObj.push({
              printType: val,
              id: item.orderCaseProjectRecipeId,
              orderType: '1'
            })
          })
          actHasOrderList.forEach(item => {
            printListObj.push({
              printType: val,
              id: item.orderCaseProjectRecipeId,
              orderType: '2'
            })
          })
          this.printListObj = printListObj
          this.$nextTick(() => {
            this.$refs.printDia.useDefaultPrint()
          })
          break;
        case '3':
          this.isBatch = false;
          this.printorderType = '4'
          this.printType = '6'
          this.printOrderId = this.orderId
          this.$nextTick(() => {
            this.$refs.printDia.useDefaultPrint()
          })
          break;
      }
    },
    /**
    * 取消打印
    */
    closePrintPrescription() {
      this.printDialogShow = false
    },
    /**
     * 打印完成
     */
    printSuccess() {

    },
    setPrintDiaShow() {
      this.printDialogShow = true
    },
    //批量打印完成
    printSuccessBatch() {
      this.$message.success('打印成功消息发送成功')
    },
    /**
* 路由参数改变调用的接口
* @param {*} page 
* @param {*} orderId 
* @param {*} webChatOrderInfoId 
*/
    async initData(page, orderId, webChatOrderInfoId) {
      if (page == 'edit' || page == 'repair' || this.page == 'webChatEdit') this.getHistoryInfo(page); // 获取病历详情
      if (webChatOrderInfoId) this.getWebChatInfo(); // 网诊详情请求
    },
    /**
    * 获取网诊详情
    */
    async getWebChatInfo() {
      let { code, data } = await webChatDetails(this.webChatOrderInfoId);
      if (code == 200) {
        data.copeWithPay = this.$toFixed(data.copeWithPay);
        this.webChatInfo = data;
        this.$forceUpdate();
        this.patientForm = data.patientInfo;
        this.$computeAge(this.patientForm.birthday, this.patientForm)
        this.editForm.price = data.price
      }
      this.loading = false;
    },
    /**
     * 滚动事件
     */
    scrollTop() {
      // console.log(this.$refs.contentWarp, 99999);
      let contentWarp = this.$refs.scrollLink
      // let height = contentWarp.scrollHeight
      contentWarp.scrollIntoView({ behavior: 'smooth' })

    },
    /**
     * 病历选择变化
     */
    async caseListChange() {
      let list = _.cloneDeep(this.chooseCaseList);
      let obj = []
      list.map(v => {
        obj.push({ propertyName: v })
      })
      await patientDTO.editCaseField(obj)
      this.getCaseFieldList()

    },
    /**
     * 设置为默认病历
     */
    async defaultCase() {
      let res = await patientDTO.restoreCaseField();
      if (res.code == 200) {
        this.getCaseFieldList()
      }
    },
    //诊断聚焦时,不满足高度向下滑动
    diagnosisFocus() {
      let pointDom = this.$refs.pointDia;
      let searchDom = this.$refs.diagnoseSelect.$el;
      let height = searchDom && searchDom.getBoundingClientRect().top;
      let domHeight = document.documentElement.offsetHeight
      let downHeight = domHeight - height
      if (downHeight < 300) {
        pointDom && pointDom.scrollIntoView({ behavior: 'smooth' })
      }
    },
    //重置历史诊断分页信息
    resetHistoryParam(){
      this.historyPageNum=1
      this.hasMoreHistoryList=true
    },
    /**
     * 添加中成药
     */
    addChineseMedicine() {
     if (isNull(this.doctorInfo.doctorId) || isNull(this.patientForm.patientId)) {
        return this.$message.error('请先填写医生、销售员和患者信息')
      }
      let obj = {
        orderId: this.orderId,
        recipeSourceType: '0',
        projectType: '0',
        recipeType: '4',
        remark: '',
        totalPrice: 0,
        items: [
          {
            itemId: '',
            itemName: '',
            deleteShow:false,
            totalPrice:0,
            useFrequency: '', //用药频次
            singleDose:'',// 单次用量
            singleDoseUnit:'',// 单次用量单位
            takingTime:'',//服用时间
            intervalRequirement:'',//时间间隔要求
          }
        ]
      }
      this.chineseMedicineItem.push(obj)
      this.$nextTick(() => {
        // this.$forceUpdate()
        let chineseMedicineCom = this.$refs.chineseMedicineCom;
        chineseMedicineCom && chineseMedicineCom.handleChineseMedicine(obj)
      })
      this.scrollTop()
    },
    //月经史内容改变
    menstrualHistoryChange(menstrualHistory){
        if(isNull(menstrualHistory) || isEmptyArray(menstrualHistory)) return;
        this.menstrualHistory = menstrualHistory
        this.editForm.menstrualHistory = isEmptyArray(menstrualHistory) ? '' : JSON.stringify(menstrualHistory);
        this.menstrualHistoryHtml = this.handleMenstrualHistoryHtml(menstrualHistory)
        this.editCaseDiagnosis();
    },
    //月经史失去焦点
    menstrualHistoryBlur(e){
      let html = e.target.innerHTML
      let menstrualHistory = this.handleMenstrualHistoryArr(html)
      this.menstrualHistory = menstrualHistory
      this.editForm.menstrualHistory = isEmptyArray(menstrualHistory) ? '' : JSON.stringify(menstrualHistory);
      this.menstrualHistoryHtml = this.handleMenstrualHistoryHtml(menstrualHistory)
      this.editCaseDiagnosis();
    },
    menstrualHistoryFocus(){
      this.menstruationShow=true
      this.menstrualHistory = this.editForm.menstrualHistory && JSON.parse(this.editForm.menstrualHistory) || []
    },
   //处理将数组处理成html
   handleMenstrualHistoryHtml(menstrualHistory){
        let html = ''
        menstrualHistory.forEach(item=>{
          if(isObject(item)){
              switch(item.type){
                case 'text':
                  if (item.text == '<br>' || item.text == '' || item.text == '，') {
                    return
                  }
                  if (html.length == 0 ) {
                    html = html + `<span>${item.text}</span>`
                  } else {
                    if(html.charAt(html.length - 8) == '，' || html.charAt(html.length - 8) == ','){
                      html = html + `<span>${item.text}</span>`
                    }else{
                      html = html + `<span>，</span><span>${item.text}</span>`
                    }
                  }
                  break;
                case 'pregnant':
                  if(item.text == '<br>' || item.pregnancyNum == '<br>' || item.childbirthNum == '<br>') return;
                  if(html.length == 0 ){
                    html = html + `<span id="pregnant">孕${item.pregnancyNum} 产${item.childbirthNum}</span><span>，</span>`
                  }else{
                    if(html.charAt(html.length - 8) == '，' || html.charAt(html.length - 8) == ','){
                      html = html + `<span id="pregnant">孕${item.pregnancyNum} 产${item.childbirthNum}</span><span>，</span>`
                    }else{
                      html = html + `<span>，</span><span id="pregnant">孕${item.pregnancyNum} 产${item.childbirthNum}</span><span>，</span>`
                    }
                  }
                  break;
                case 'menstruation':
                  if(isNull(item.menarcheAge)) return;
                  if(html.length == 0 ){
                    html = html + `<span id="menstruation" class="flex align-i-c"><span id="menarcheAge">${isNull(item.menarcheAge) ? '' : item.menarcheAge}</span><span class="flex flex-col w40 size12 tac ml8 mr8"> <span id="menstruationDays">${this.filterMenstrual(item.menstruationDays)}</span> <span class="frasl"></span><span id="menstrualCycle">${this.filterMenstrual(item.menstrualCycle)}</span></span>${isNull(item.menopauseDate)?'':`<span id="menopauseDate">LMP ${item.menopauseDate}</span>`}${isNull(item.menopauseAge)?'':`<span class='ml8' id="menopauseAge">${item.menopauseAge}</span>`}</span><span>，</span>`
                  }else{
                    if(html.charAt(html.length - 8) == '，' || html.charAt(html.length - 8) == ','){
                      html = html + `<span id="menstruation" class="flex align-i-c"><span id="menarcheAge">${isNull(item.menarcheAge) ? '' : item.menarcheAge}</span><span class="flex flex-col w40 size12 tac ml8 mr8"> <span id="menstruationDays">${this.filterMenstrual(item.menstruationDays)}</span> <span class="frasl"></span><span id="menstrualCycle">${this.filterMenstrual(item.menstrualCycle)}</span></span>${isNull(item.menopauseDate)?'':`<span id="menopauseDate">LMP ${item.menopauseDate}</span>`}${isNull(item.menopauseAge)?'':`<span class='ml8' id="menopauseAge">${item.menopauseAge}</span>`}</span><span>，</span>`
                    }else{
                      html = html + `<span>，</span><span id="menstruation" class="flex align-i-c"><span id="menarcheAge">${isNull(item.menarcheAge) ? '' : item.menarcheAge}</span><span class="flex flex-col w40 size12 tac ml8 mr8"> <span id="menstruationDays">${this.filterMenstrual(item.menstruationDays)}</span> <span class="frasl"></span><span id="menstrualCycle">${this.filterMenstrual(item.menstrualCycle)}</span></span>${isNull(item.menopauseDate)?'':`<span id="menopauseDate">LMP ${item.menopauseDate}</span>`}${isNull(item.menopauseAge)?'':`<span class='ml8' id="menopauseAge">${item.menopauseAge}</span>`}</span><span>，</span>`
                    }
                  }
                  break;
              }
          }
        })
        return html;
    },
    //特殊处理‘,</span></span>’的不规范数据，把，挪到最后</span></span>后面
    handleSpanData(){},
    //处理将html处理成数组
    handleMenstrualHistoryArr(html){
      if(isNull(html)){
        return [];
      }else{
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const body = doc.body;
        const result = [];

        function traverse(node) {
          if (node.nodeType === Node.TEXT_NODE) {
            // 文本节点，过滤掉空白文本
            let text = node.textContent.trim();
            text = text.replace(/^，|，$/g, '')
            if (text) {
              result.push(`<span>${text}</span>`);
            }
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            let text = node.outerHTML.replace(/^<span>，/g, '<span>')
            text = text.replace(/^，<\/span>$/g, '</span>')
            // 元素节点
            result.push(text);
          }
        }

        body.childNodes.forEach(node => traverse(node));

        let arr= [];
        let list = result
        if (isEmptyArray(list)) {
          return
        }
        list.forEach(item=>{
          if(item.includes('span')){
            if(item.includes('pregnant')){
              let data =  getSpanData(item,0)
              let pregnancyNum = Number(getContentBetween(data,'孕','产'))
              let childbirthNum = data.slice(data.indexOf('产')+1)
              let obj = {
                pregnancyNum,childbirthNum,type:'pregnant',text:data
              }
              arr.push(obj)
            }else if(item.includes('menstruation')){
              let obj = {type:'menstruation',menarcheAge:null,menstruationDays:[],menstrualCycle:[],menopauseDate:null,menopauseAge:null}
              const regex = /<span[^>]*>([^<]*)<\/span>/g;
              const matches = item.match(regex);
              matches && matches.forEach(span=>{
                if(span.includes('menarcheAge')){
                  obj.menarcheAge= getSpanData(span,0)
                  obj.text = obj.menarcheAge
                }else if(span.includes('menstruationDays')){
                  let data = getSpanData(span,0)
                  if(data.includes('~')){
                    obj.menstruationDays = data.split('~')
                  }else{
                    obj.menstruationDays[0]=data
                  }
                  obj.text = `${obj.text} (${data})/`
                }else if(span.includes('menstrualCycle')){
                  let data = getSpanData(span,0)
                  if(data.includes('~')){
                    obj.menstrualCycle = data.split('~')
                  }else{
                    obj.menstrualCycle[0]=data
                  }
                  obj.text = `${obj.text}(${data})`
                }else if(span.includes('menopauseDate')){
                  obj.menopauseDate= getSpanData(span,0).slice(-10)
                  obj.text = `${obj.text} LMP ${obj.menopauseDate}`
                }else if(span.includes('menopauseAge')){
                  obj.menopauseAge= getSpanData(span,0)
                  obj.text = `${obj.text} ${obj.menopauseAge}`
                }
              })
              arr.push(obj)
            }else{
              let data = getSpanData(item,0)
              arr.push({type:'text',text:data})
            }
          }else{
            arr.push({type:'text',text:item})
          }
        })
        return arr;
      }
    },
    //关闭挂号弹框
    closeRegister(){
      this.registerObj.show = false;
      this.registerObj.patientInfo = {};
      this.registerObj.doctorInfo = {};
    },
    //打开挂号弹框
    openRegister(){
      this.registerObj.patientInfo = this.patientForm;
      this.registerObj.show = true;
      this.registerObj.doctorInfo = this.doctorInfo;
    },

    // 选择复诊时间
    changeRepeatVisitDateHandle() {
      if (this.repeatVisitInfo.dateVal !== '') {
        this.repeatVisitInfo.revisitFlag = '1'
      }
      this.editCaseDiagnosis()
    },

    // 选择复诊/无需复诊checkbox
    changeRepeatVisitHandle(e,value) {
      if(e === false){
        this.repeatVisitInfo.revisitFlag = value
      }else{
        this.repeatVisitInfo.revisitFlag = e
      }
      if (['0','2'].includes(e)) {
        this.repeatVisitInfo.dateVal = ''
      }
      this.editCaseDiagnosis()
    },

    // 匹配remark
    inputRemarkHandle: _.debounce(function() {
      this.searchRemarkHandle()
      this.editCaseDiagnosis()
    }, 300),

    // 匹配remark
    searchRemarkHandle() {
      const remarkResultList = this.repeatVisitInfo.remarkInfo.remarkList.filter(item => item.includes(this.repeatVisitInfo.remarkInfo.remark))
      this.repeatVisitInfo.remarkInfo.showRemark = remarkResultList.length > 0
      this.repeatVisitInfo.remarkInfo.remarkResultList = remarkResultList
    },

    // 选择复诊备注
    setRemarkHandle(str = '') {
      this.repeatVisitInfo.remarkInfo.remark = str
      this.repeatVisitInfo.remarkInfo.showRemark = false
      this.editCaseDiagnosis()
    },
    //查询是否具有充值潜力
    async getChargePotential() { 
      let { drugItem, physioItem, chineseMedicineItem, otherItem, actList } = this
      // 充值金额列表
      let rechargeList = process.env.VUE_APP_ENV === 'production' ? productRechargeList : testRechargeList
      let topLevel = []
      rechargeList.forEach(v=>{topLevel.push(v.amt)})
      if(isNull(this.patientForm.patientId)) return;
      let params = {
        companyId:10,
        param:{
          patientId:this.patientForm.patientId + '',
          payAmount:Number(this.computeTotalPrice1(drugItem, physioItem, chineseMedicineItem, otherItem, actList)),
          needRevisit:this.repeatVisitInfo.revisitFlag == '0' ? 0 : 1,
          topLevel:topLevel.join(',')
        }, 
        tpCode:'TPH001'
      }
      let {errorCode,data} = await touchPoint(params)
      if(errorCode == '0000'){
        this.chargePotential = data
      }
    },
    async stopRecording(obj){ 
      if(isNull(obj.text.trim())){
        this.$message.error('未识别到语音，请重试')
        return 
      }
      let diagnosisParams={
       companyId: 10,
       userId: this.doctorInfo.doctorId,
       audioTime: obj.time,
       diagnosisId: this.orderId,
       userMessage: obj.text.trim(),
      //  userMessage: '总是胃痛考虑是慢性胃炎食欲不佳饮食不规律,在睡觉的时候头也经常会痛',
       patientSex: isNull(this.patientForm.sex) ? '' : dictText(this.patientForm.sex, sexDict),
       pastMedicalHistory: this.editForm.previousHistory || '',
       allergies:this.editForm.allergyHistory || '',
      }
      this.voiceObj.diagnosisParams = diagnosisParams
      this.voiceObj.recordShow = false
      this.voiceObj.diagnosisShow = true
    },
    async openVoice(){
      if(this.isDisabled) return;
      getVersion({},{timeout: 1000}).then(res=>{
        if(res.code==200){
          this.voiceObj.recordShow = true
        }
      }).catch(()=>{
        this.$message.error('该功能还未开放！')
      })
    },
    closeAIDiagnosis(){
      this.voiceObj.diagnosisShow = false
    },
    voiceDialogClose(){
      this.voiceObj.recordShow = false
    },
    adopt(diagnosis){
      let obj = diagnosis.records
      const map = {
        '主诉':'patientTell',
        '家族史':'familyHistory',
        '既往病史':'previousHistory',
        '现病史':'presentCondition',
        '过敏史':'allergyHistory'
      }
     if(!isNull(obj) && !isNullObj(obj)){
      for (const objKey in obj) {
        for (const mapKey in map) {
          if(objKey == mapKey){
            this.editForm[map[mapKey]] = map[mapKey] == 'patientTell' &&  !isNull(this.editForm[map[mapKey]]) ? `${this.editForm[map[mapKey]]}***${obj[objKey]}` : obj[objKey]
          }
        }
        if(objKey == '建议诊断' && obj[objKey] !='无'){
          let list = obj[objKey].split(',') 
          let diagnosisList = []
          list && list.forEach(v=>{
            diagnosisList.push({
              diagnoseCode:'',
              diagnoseName:v
            })
          })
          let name= diagnosisList.map(v=>v.diagnoseName).join(';');
          this.diagnosObj.diagnosName=name || ''
          this.editForm.diagnosisList = diagnosisList
        }
      }
     }
     this.voiceObj.diagnosisShow = false
     console.log(this.editForm,1111);
    },
     startDrag(e) {
      this.isDragging = true
      this.startX = e.clientX
      this.startY = e.clientY
      
      const rect = this.$refs.draggableBox.getBoundingClientRect()
      this.offsetX = this.startX - rect.left
      this.offsetY = this.startY - rect.top
      
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.stopDrag)
    },
    onDrag(e) {
      if (!this.isDragging) return
      
      const x = e.clientX - this.offsetX
      const y = e.clientY - this.offsetY
      
      // 限制在容器内
      const container = this.$el.getBoundingClientRect()
      const maxX = container.width - this.$refs.draggableBox.offsetWidth
      const maxY = container.height - this.$refs.draggableBox.offsetHeight
      
      this.boxStyle.left = `${Math.min(Math.max(0, x - container.left), maxX)}px`
      this.boxStyle.top = `${Math.min(Math.max(0, y - container.top), maxY)}px`
    },
    stopDrag() {
      this.isDragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.stopDrag)
    },
    presentConditionFocus(){
      this.presentConditionShow=true
    },
    previousHistoryFocus(){
      this.previousHistoryShow=true
    },
    allergyHistoryFocus(){
      this.allergyHistoryShow=true
    },
    presentConditionChange(list){
      this.editForm.presentCondition = isEmptyArray(list) || isNull(list) ? '' : list.join(',')
      this.editCaseDiagnosis()
    },
    previousHistoryChange(list){
      this.editForm.previousHistory = isEmptyArray(list) || isNull(list) ? '' : list.join(',')
      this.editCaseDiagnosis()
    },
    allergyHistoryChange(list){
      this.editForm.allergyHistory = isEmptyArray(list) || isNull(list) ? '' : list.join(',')
      this.editCaseDiagnosis()
    },
    // 获取理疗资产
    async getPhysioProperty(){
      let {code,data} = await getAccountPhysioProperty({deptId: 'all',doctorId:this.doctorInfo.doctorId,patientId:this.patientForm.patientId})
      if(code==200){
        this.physioAssetList = data || []
        this.physioAssetTotal = isNull(data) ? 0 : data.length
      }
    },
    assistantRemarkChange(list){
      this.editForm.preNotes = isEmptyArray(list) || isNull(list) ? '' : list.join(',')
      this.editCaseDiagnosis()
    },
    onlineInfoUpdate () {
      this.$refs['outpatientLeft'].getOnlineList(2)
      this.getNewInfo()
      this.getOutPatientAll(this.orderId)
    },
    // 再次开方
    createOrderAgain () {
      const initInfo = {
        deptId: this.deptId,
        doctorId: this.doctorId,
        orderType: "0",
        patientId: this.patientForm.patientId,
        price: this.isRegister.price || this.isRegister.registeredPrice
      }
      this.$refs['outpatientLeft'].fastPrescription(initInfo)
    },
    findPriceRange(val, configs) {
      for (let i = 0; i < configs.length; i++) {
        const config = configs[i];
        const ladderStartNumber = config.ladderStartNumber;
        const ladderEndNumber = config.ladderEndNumber;
        // 处理max为空字符串的情况（表示无上限）
        if (isNull(ladderEndNumber)) {
          if (val >= ladderStartNumber) {
            return config;
          }
        } 
        // 正常区间判断
        else {
          if (val >= ladderStartNumber && val <= ladderEndNumber) {
            return config;
          }
        }
      }
      // 没有找到匹配的区间
      return null;
    },
    // 获取复诊价格
    async getRevisitRegisterPrice() {
      if (isNull(this.doctorId) || isNull(this.patientForm.patientId)) return;
      let { code, data } = await getRevisitRegisterPrice({
        deptId: this.deptId,
        doctorId: this.doctorId,
        patientId: this.patientForm.patientId,
        registerType: '0'
      })
      if (code == 200) {
        this.isRegister.price = data.finalPrice
      }
    },
    referralOpen() {
      this.referralMap.show = true
    },
    referralClose() {
      this.referralMap.form.doctorId = ''
      this.$nextTick(() => {
        this.$refs.referralForm.clearValidate()
        this.referralMap.show = false
      })
    },
    referralConfirm: debounce(async function () {
      this.$refs.referralForm.validate(async (valid) => {
        if (valid) {
          const res = await setOrderReferral({
            orderId: this.chooseLeftPatientInfo.order.orderId,
            doctorId: this.referralMap.form.doctorId
          })
          if (res.code == 200) {
            this.referralClose()
            this.$message.success('转诊成功')
            this.$refs['outpatientLeft'].getOutlineList(1)
          }
        }
      })
    }, 1000, true),
    // 选择套餐
    async submitComboSelect (info) {
      const hasActivity = this.actList.some(v => v.actNumber === info.number)
      if (hasActivity) {
        this.$message.error('套餐已添加')
        return
      }
      const physioList = info.physios.filter(v => {
        v['drugType'] = 1
        v['itemName'] = v.drugName
        v['spuCommonName'] = v.drugName
        v['itemUnit'] = v.unit
        v['executeCount'] = null
        v['executeDesc'] = null
        v['executeInterval'] = null
        v['physioExtendJson'] = {
          acupointinfoList: [],
          executionMode: v.executionMode,
          onlyNum: v.groupCount,
          perUnit: v.perUnit,
          perUnitCount: v.perUnitCount,
          physioIntervalEnum: null,
          soldNum: v.executionMode === 20 ? v.itemNum * v.groupCount : v.itemNum
        }
        return v.itemNum > 0
      })
      const drugList = info.drugs.filter(v => {
        v['drugType'] = 2
        v['itemName'] = v.drugName
        v['spuCommonName'] = v.drugName
        v['itemUnit'] = v.unit
        v['executeCount'] = null
        v['executeDesc'] = null
        v['executeInterval'] = null
        return v.itemNum > 0
      })

      if (this.isDisabled || this.isEdit) {
        const activity = {
          actNumber: info.number,
          actCseName: info.cseName,
          actCount: info.count,
          totalPrice: Math.round(info.count * info.price * 100) / 100,
          items: [...physioList, ...drugList]
        }
        this.actList.push(activity)
        this.$message.success('套餐添加成功')
        this.$refs['comboSelect'].close()
      } else {
        const params = {
          deptId: this.deptId,
          orderId: this.orderId,
          actNumber: info.number,
          actCount: info.count,
          items: [...physioList, ...drugList]
        }

        const res = await postCombSaleSelect(params)

        if (res.code === 200) {
          this.$message.success('套餐添加成功')
          this.$refs['outpatientLeft'].getOutlineList(1)
          this.$refs['comboSelect'].close()
        }
      }
    },
    // 刷新订单信息
    refreshOrder () {
      this.$refs['outpatientLeft'].getOutlineList(1)
    },
    // 获取诊前知己内容
    async getDoctorPatientSummary() {
      this.doctorPatientSummary = null;
      if (isNull(this.doctorId) || isNull(this.patientForm.patientId)) return;
      let {code,data} = await getDoctorPatientSummary({doctorId:this.doctorId,patientId:this.patientForm.patientId})
      if(code==200){
        this.doctorPatientSummary = data
      }
    },
    showPreConsultationHelper(){
      window.$trackTool.track({ v: '1', b: 'his_000011', t: 'his_0003' }, { updateTime: new Date().Format('yyyy-MM-dd hh:mm:ss'), orderId: this.orderId,doctorId: this.doctorId })
    },
  }
}
</script>

<style lang="less" src="./index.less" scoped></style>

<style lang="less">
.upload_box>input {
  width: 50px !important;
  height: 50px !important;
}

.diagnosePop {
  padding: 0;
  width: 800px;
}

.el-popover.popover-log {
  padding: 10px;
  background-color: #fffeec;
}
.preNotes-popper{
  max-width: 400px;
  background-color: #FFFDE9 !important;
  font-weight: 400;
  font-size: 14px;
  color: #667182;
  box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.15) !important;
  border-radius: 2px 2px 2px 2px !important;
  border: none !important;
}
</style>
